<template>
  <div class="message" style="height: calc(100vh - 64px)">
    <!-- SVG Sprite Definitions -->
    <svg style="display: none">
      <defs>
        <symbol id="message-icon" viewBox="0 0 24 24">
          <path d="M20 2H4a2 2 0 0 0-2 2v18l4-4h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2M6 9h12v2H6m8 3H6v-2h8m4-4H6V6h12" />
        </symbol>
        <symbol id="email-icon" viewBox="0 0 24 24">
          <path
            d="m20 8l-8 5l-8-5V6l8 5l8-5m0-2H4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2" />
        </symbol>
        <symbol id="gift-icon" viewBox="0 0 24 24">
          <path
            d="M19.828 12.403h-7.172V21h7.172v-8.597zM11.348 12.403H4.176V21h7.172v-8.597zM17.591 5.504a2.26 2.26 0 0 0 .305-1.132C17.896 3.064 16.773 2 15.393 2c-1.021 0-2.066.5-2.866 1.371A4.846 4.846 0 0 0 12 4.06a4.846 4.846 0 0 0-.527-.689C10.673 2.5 9.628 2 8.607 2c-1.38 0-2.503 1.064-2.503 2.372 0 .41.11.796.305 1.132H3v5.66h8.346v-5.66h1.308v5.66H21v-5.66h-3.409zm-8.984 0c-.659 0-1.195-.508-1.195-1.132 0-.625.536-1.133 1.195-1.133 1.187 0 2.315 1.15 2.644 2.265H8.607zm6.786 0h-2.644c.329-1.115 1.457-2.265 2.644-2.265.659 0 1.195.508 1.195 1.133 0 .624-.536 1.132-1.195 1.132z" />
        </symbol>
      </defs>
    </svg>
    <div class="left" :style="{ width: leftWidth + '%' }">
      <div class="leftTopBox">
        <newMessageCard @message-click="clickNewMessage" @unreadCountChanged="handleUnreadCountChanged"
          ref="newMessagePanel" />
      </div>
    </div>
    <!-- 左侧拖拽条 -->
    <div class="resize-handle left-handle" @mousedown="startResize($event, 'left')"
      @touchstart="startResize($event, 'left')"></div>
    <div class="center relative" :style="{ width: centerWidth + '%' }" v-if="chatUserInfo.platformUserId">
      <!-- 超过5分钟未回复的悬浮提示 - 基于底部定位 -->
      <div v-if="hasOver5MinutesUnreplied" class="urgent-floating-tip-bottom">
        超过5分钟未回复
      </div>
      <div class="absolute top-100px pd-y-4 pd-x-20 br-50 limit-status-bar"
        style="left: 50%; transform: translateX(-50%)">
        <el-tooltip v-for="(item, index) in limitStatus" :key="index"
          :content="item.content ? `${item.content}: ${item.text}` : ``" placement="top" effect="light"
          :open-delay="500">
          <div class="limit-item">
            <svg v-if="item.type != ''" class="limit-icon" :class="{ disabled: !item.available }" viewBox="0 0 24 24"
              fill="currentColor">
              <use :href="`#${item.type}-icon`"></use>
            </svg>
            <span class="limit-text" :class="{ disabled: !item.available }">
              {{ item.text }}
            </span>
          </div>
        </el-tooltip>
      </div>
      <div class="center_title">
        <div class="flex flex1 row between">
          <div class="flex flex1 row middle between">
            <card :userDetail="chatUserInfo.userDetail" :id="chatUserInfo.userId" :userMood="userMood"
              :isRightCard="false" :chatUserInfo="chatUserInfo" :historyList="historyList" />
            <card :platformUserDetail="chatUserInfo.platformUserDetail" :id="chatUserInfo.platformUserId"
              :isRightCard="true" :chatUserInfo="chatUserInfo" :historyList="historyList" />
          </div>
          <!-- 消息类型切换按钮 -->
          <div class="message-type-switch">
            <el-button type="primary" size="small" @click="toggleMessageType" class="toggle-switch-btn" :title="currentMessageType === 'chat' ? '切换到邮件' : '切换到消息'
              ">
              <i :class="currentMessageType === 'chat'
                ? 'el-icon-message'
                : 'el-icon-chat-line-square'
                "></i>
              {{ currentMessageType === 'chat' ? '邮件' : '消息' }}
            </el-button>
          </div>
          <OperationGroup :chatUserInfo="chatUserInfo" :isShowingPinnedMessages="isShowingPinnedMessages"
            @user-deleted="handleUserDeleted" @view-pinned-messages="handleViewPinnedMessages"
            @view-media-history="handleViewMediaHistory" />
        </div>
      </div>
      <div id="infoList" class="infoList" ref="messageList" @scroll="handleScroll">
        <div v-if="
          chatMessageList.length > 0 &&
          loading &&
          currentMessageType == 'chat'
        " class="flex row middle pt-30 pb-10" style="justify-content: center">
          <i class="el-icon-loading fs-24 color-black"></i>
        </div>
        <div v-if="
          chatMessageList.length == 0 &&
          (loading || systemMessageLoading) &&
          currentMessageType == 'chat'
        " class="loading-container">
          <div class="loading-spinner"></div>
          <div class="loading-text">正在加载聊天...</div>
        </div>
        <template v-else-if="chatMessageList.length > 0 && currentMessageType == 'chat'">
          <messageInfo v-for="(item, index) in chatMessageList" :key="item.id || item.requestId || index"
            :ref="'msg-' + (item.id || item.requestId)" :rowData="item" :type="item.type" :chatUserInfo="chatUserInfo"
            @getHistoryList="getHistoryList" @retryMessage="retryMessage" />
        </template>
        <template v-else-if="currentMessageType == 'email'">
          <emailDetailList v-if="emailId" :chatUserInfo="chatUserInfo" ref="emailDetailListDom" :emailId="emailId" />
          <div v-else class="empty-email-container">
            <div class="empty-email-message">
              <i class="el-icon-message"></i>
              <p>还没有邮件往来</p>
              <p>发送第一封邮件开始对话吧</p>
            </div>
          </div>
        </template>
        <template v-else-if="
          !loading &&
          !systemMessageLoading &&
          chatMessageList.length === 0 &&
          currentMessageType == 'chat'
        ">
          <div v-if="chatUserInfo.systemMessage" class="absolute bottom-20 w100">
            <div class="max-w-400 pd-y-8 pd-x-16 bg---blue-10 br-8 mg-auto mb-15 color---blue-500">
              {{ chatUserInfo.systemMessage.content.message }}
            </div>
          </div>
          <div v-else class="empty-chat-container">
            <div class="empty-chat-content">
              <div class="empty-chat-icon">
                <img src="@/assets/chat1.png" alt="" />
              </div>
              <div class="empty-chat-title">暂无聊天记录</div>
              <div class="empty-chat-subtitle">开始发送消息吧</div>
            </div>

            <!-- 媒体历史组件 -->
            <MediaHistory ref="mediaHistory" />
          </div>
        </template>
      </div>
      <div v-if="chatUserInfo.isBlocked !== true" class="input">
        <div class="items_iconList">
          <!-- 表情列表 -->
          <emoji-picker :on-insert-emoji="insertEmoji" />
          <!-- 贴纸列表 -->
          <sticker-picker v-if="currentMessageType !== 'email'" :stickers-list="stickersList"
            @sticker-select="postStickers" />
          <!-- 礼物列表 -->
          <gift-picker ref="giftPicker" v-if="currentMessageType !== 'email'" :category-list="tabTheGiftList"
            :gift-list="currentGiftList" :can-send-gift="canSendGift" @category-change="handleGiftCategoryChange"
            @gift-select="theGiftsBtn" />
          <!-- 快捷消息列表 -->
          <el-dropdown v-if="currentMessageType !== 'email'" placement="top-start" trigger="click" ref="qMsgDropdown">
            <span class="el-dropdown-link" @click="getqMsgFun()">
              <img class="icon pointer" src="@/assets/qReply.png" alt="快捷消息" title="快捷消息" />
            </span>
            <el-dropdown-menu class="stickersClass" style="width: 420px">
              <div class="msgTabListBox">
                <div class="leftBox">快捷消息(仅限10条)</div>
                <div class="rightBox">
                  <i class="el-icon-circle-plus-outline" @click="editQMsgFun"></i>
                </div>
              </div>
              <div class="msgListBox" v-if="qMsgDataList.length > 0">
                <el-dropdown-item v-for="(item, index) in qMsgDataList" :key="index">
                  <div class="msgLiBox">
                    <div class="leftBox" @click="checkQMsg(item.description)">
                      {{ item.description }}
                    </div>
                    <div class="rightBox" @click="senQMsg(item.description)">
                      <img src="../../../../assets/send.png" style="width: 15px; height: 15px" alt="" srcset="" />
                    </div>
                  </div>
                </el-dropdown-item>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
          <div class="item pointer" v-for="item in filteredTools" :key="item.id" @click="itemClick(item.id)"
            :alt="item.name" :title="item.name" :class="{
              disabled:
                (item.name === '礼物' && !canSendGift) ||
                (item.name === '帖子' && !canSendPosts) ||
                (item.name === '附加文件' &&
                  currentMessageType === 'email' &&
                  !(emailLimit > 0)) ||
                (item.name === '附加文件' &&
                  currentMessageType === 'chat' &&
                  !(messageLimit > 0)) ||
                (item.name !== '礼物' &&
                  item.name !== '帖子' &&
                  item.name !== '翻译' &&
                  item.name !== '附加文件' &&
                  !canSendMessage),
            }" @close="close(item)">
            <template v-if="item.name == '翻译'">
              <chooseTranslation @checkQMsg="checkQMsg" :message="message" ref="chooseTra">
              </chooseTranslation>
            </template>
            <template v-else-if="item.id == 'sendFiles'">
              <el-upload ref="uploader" class="upload-demo" action="#" :show-file-list="false" :auto-upload="false"
                :on-remove="handleRemove" :before-remove="beforeRemove" :limit="1" :on-change="handleChange"
                accept=".jpg,.jpeg,.png,.xbm,.tif,.pjp,.apng,.svgz,.icon,.tiff,.gif,svg,.jfif,.webp,.bmp,.pjpeg,.avif,.ogm,.wmv,.mpg,.webm,.ogv,.mov,.asx,.mpeg,.mp4,.m4v,.avi">
                <img class="item_img w-24" :src="item.url" alt="" />
              </el-upload>
            </template>
            <template v-else>
              <img class="item_img" :src="item.url" alt="" :style="{
                width: item.width + 'px',
                height: item.height + 'px',
              }" />
            </template>
          </div>
        </div>
        <!-- 邮件附件展示区域 -->
        <div v-if="currentMessageType === 'email' && emailUploadedFiles.length > 0" class="email-files-container">
          <div class="email-files-scroll">
            <div class="email-files-list">
              <div v-for="(file, index) in emailUploadedFiles" :key="file.id" class="file-item">
                <div class="file-thumbnail">
                  <!-- 图片文件显示缩略图 -->
                  <img v-if="file.type === 'image' && file.url" :src="file.url" :alt="file.name" class="file-image" />
                  <!-- 视频文件显示缩略图 -->
                  <video v-else-if="file.type === 'video' && file.url" :src="file.url" class="file-video" muted
                    preload="metadata">
                    <source :src="file.url" type="video/mp4" />
                  </video>
                  <!-- 其他文件类型显示图标 -->
                  <div v-else class="file-icon">
                    <i v-if="file.type === 'audio'" class="el-icon-headset"></i>
                    <i v-else class="el-icon-document"></i>
                  </div>
                </div>
                <div class="file-actions">
                  <el-button type="text" size="mini" @click="removeEmailFile(index)" class="remove-btn">
                    <i class="el-icon-close"></i>
                  </el-button>
                </div>
              </div>
            </div>
          </div>
          <!-- 清空按钮 -->
          <el-button type="text" size="mini" @click="clearEmailFiles" class="clear-btn" title="清空所有附件">
            <i class="el-icon-delete"></i>
          </el-button>
        </div>
        <div class="input_info">
          <!-- 敏感词高亮显示层 -->
          <div v-if="message" ref="highlightOverlay" class="highlight-overlay" v-html="$highlight(message)"></div>
          <textarea ref="editor" v-model="message" class="messageInput" @paste="handlePaste" :placeholder="currentMessageType === 'email'
            ? '请输入邮件内容（至少150个字符）...'
            : '请输入消息...'
            " @keydown="keydownEvent" @scroll="handleInputScroll" rows="1"></textarea>
          <img class="send_icon" :class="{
            disabled:
              currentMessageType === 'email'
                ? !(this.emailLimit > 0)
                : !(this.messageLimit > 0),
          }" @click="itemClick(0)" src="@/assets/send.png" alt="" :title="currentMessageType === 'email'
            ? this.emailLimit > 0
              ? '发送邮件'
              : '邮件数量不足'
            : this.messageLimit > 0
              ? '发送消息'
              : '消息数量不足'
            " />
        </div>
      </div>
      <div v-else class="input blocked-input">
        <div class="blocked-message">
          <div class="blocked-icon">
            <i class="el-icon-warning-outline"></i>
          </div>
          <div class="blocked-text">
            <div class="blocked-title">您已被对方拉黑，无法发送消息</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 占位聊天框 -->
    <div class="center empty-chat" :style="{ width: centerWidth + '%' }" v-else>
      <div class="empty-chat-content">
        <div class="empty-icon">
          <img src="@/assets/logo/128x128.png" alt="" />
        </div>
        <div class="empty-title">欢迎使用XChatSpace</div>
        <div class="empty-subtitle">请选择一个对话开始聊天</div>
      </div>
    </div>
    <!-- 右侧拖拽条 -->
    <div class="resize-handle right-handle" @mousedown="startResize($event, 'right')"
      @touchstart="startResize($event, 'right')"></div>
    <div class="right" :style="{ width: rightWidth + '%' }">
      <rightPanel :historyList="historyList" :loadingImgShow="loadingImgShow" :createQMsgTypeShow="createQMsgTypeShow"
        :hasMore="isHistoryMore" @selectChange="handleSelectChange" @refresh="refreshFun" @clickHistory="clickHistory"
        @loadMore="loadMoreHistory" ref="rightPanelDom" />
    </div>
    <userInfo ref="userInfoDom" :platformUserId="chatUserInfo.platformUserId" />
    <el-dialog :visible.sync="RecordingShow" width="500px">
      <div class="RecordingShow">
        <div class="recordingContent">
          <img class="img" src="@/assets/recordingIcon.png" alt="" />
          <div v-if="isRecording" class="text">
            正在录制(<span class="color-red">{{ recordTime }}s</span>)
          </div>
          <div v-else>
            <div v-if="createAudioUrl" class="text">录音生成中...</div>
            <audio v-else-if="audioUrl" :src="audioUrl" controls></audio>
            <div v-else class="text">请开始录制语音</div>
          </div>
        </div>

        <div class="buttons">
          <div class="item" v-if="isRecording" @click="stopRecording">
            结束录制
          </div>
          <div class="item" v-else @click="startRecording">开始录制</div>
          <div class="item" @click="sendRecording">发送语音</div>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="" class="emailDialog" :visible.sync="emailShow" width="825px" :before-close="handleClose">
      <sendEmail :chatUserInfo="chatUserInfo" :emailType="emailType" @generatingEmail="generatingEmail"
        @sendEmailFn="sendEmailFn" :datingEmailLoading="datingEmailLoading" @itemClick="itemClick"
        :emailFileList="emailFileList"></sendEmail>
    </el-dialog>
    <!-- 附件 -->
    <attachment ref="attachmentDom" :chatUserInfo="chatUserInfo" @send-sonMediaMessage="sendSonMediaMessage"
      :currentMessageType="currentMessageType">
    </attachment>

    <!-- 快捷消息 -->
    <el-dialog title="" :visible.sync="qMsgShow" width="825px" :before-close="qMsgClose">
      <qMsgMark :isShow="qMsgShow" :chatUserInfo="chatUserInfo"></qMsgMark>
    </el-dialog>

    <!-- 举报 -->
    <el-dialog :visible.sync="userReportShow" width="825px" :before-close="userReportClose">
      <userReport :isShow="userReportShow" :chatUserInfo="chatUserInfo" @userReportClose="userReportClose">
      </userReport>
    </el-dialog>

    <!-- 消息发送失败弹窗 -->
    <el-dialog :visible.sync="sendFailDialogShow" :close-on-click-modal="false" :close-on-press-escape="false"
      class="send-fail-dialog-wrapper" width="600px" :show-close="true" center>
      <div class="send-fail-dialog">
        <div class="dialog-header">
          <div class="warning-icon-bg">
            <i class="el-icon-warning-outline"></i>
          </div>
          <h3 class="dialog-title">消息发送失败</h3>
        </div>
        <div class="dialog-content">
          <p class="main-text">{{ failMsg }}</p>
        </div>
        <div class="dialog-buttons">
          <el-button @click="handleSendFailAction('later')" class="dialog-btn">
            <i class="el-icon-check"></i>
            好的
          </el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 礼物发送弹窗 -->
    <SendGiftModal :visible="sendGiftModalVisible" :gift="selectedGift" :user="chatUserInfo.userDetail"
      @close="sendGiftModalVisible = false" @send="handleSendGiftWithMessage" />

    <!-- 礼物提示弹窗 -->
    <GiftPromptModal :visible="giftPromptModalVisible" :user="chatUserInfo.userDetail"
      @close="giftPromptModalVisible = false" @confirm="handleGiftPromptConfirm" />

    <!-- 媒体历史组件 -->
    <MediaHistory ref="mediaHistory" />
  </div>
</template>

<script>
import card from './components/card';
import messageCard from './components/messageCard';
import unreadMessage from './components/unreadMessage';
import messageInfo from './components/messageInfo';
import userInfo from './components/userInfo';
import sendEmail from './components/sendEmail';
import newMessageCard from './components/newMessageCard';
import attachment from './components/attachment.vue';
import qMsgMark from './components/qMsgMark.vue';
import qMsgTypeCreateMark from './components/qMsgTypeCreateMark.vue';
import allMyUsers from './components/allMyUsers.vue';
import userReport from './components/userReport.vue';
import chooseTranslation from './components/chooseTranslation.vue';
import rightPanel from './components/rightPanel.vue';
import recorder from '@/utils/audio-recorder';
import localLogger from '@/utils/log.js';
import { getToken } from '@/utils/auth';
import store from '@/store';
import _ from 'lodash';
import {
  getDialogueList,
  getSmilesList,
  getEmailCoverList,
  delChat,
  readNoticeMessage,
} from '@/api/dialogue';
import { chatFavorite, reSubscribe } from '@/api/user';
import { getTalkytimesUserInfo, getOnlineStatus } from '@/api/talkytimes/user';
import { sendDatingMessage } from '@/api/dating';
import { quickMessageTypeList, quickMessageList } from '@/api/attachment';
import { getEmailPhotoForbiddenTags } from '@/api/talkytimes/attachment';
import { delPdNoReplyChatBoxes } from '@/api/dialogue';
import emailDetailList from './components/emailDetailList';
import OperationGroup from './components/operationGroup.vue';
import MediaHistory from './components/mediaHistory.vue';

import { generateUUID } from '@/utils/chat';
import { setVueInstance } from '@/utils/talky_muti_chat.js';
import globalWebSocketManager from '@/utils/globalWebSocketManager';
// talkytimes接口
import {
  getConversationStarterList,
  getChatDialogsByCriteria,
  getChatMessages,
  getRecentStickers,
  getStickers,
  getGiftList,
  sendSticker,
  sendGalleryPhotos,
  sendGalleryVideo,
  sendAudio,
  uploadFile,
  sendText,
  sendVirtualGift,
  getMessageLimit,
  getEmailLimit,
  getGiftStatus,
  getGiftLimit,
  getPresentIsAvailable,
  sendLetter,
  getUserIsVip,
  getEmailId,
  getFeatureFlagList,
  readMessage,
  readChat,
  getPinnedMessages,
  getChatDialogsByPairs,
} from '@/api/talkytimes/message';
import EmojiPicker from './components/emoji-picker.vue';
import StickerPicker from './components/sticker-picker.vue';
import GiftPicker from './components/gift-picker.vue';
import SendGiftModal from './components/SendGiftModal.vue';
import GiftPromptModal from './components/GiftPromptModal.vue';
import sseManager from '@/utils/sseManager';
import { getConnectionsProfiles } from '@/api/talkytimes/personalData';
import { selectCanSendPost } from '@/api/talkytimes_user';
export default {
  components: {
    card,
    messageCard,
    messageInfo,
    userInfo,
    newMessageCard,
    sendEmail,
    attachment,
    qMsgMark,
    qMsgTypeCreateMark,
    allMyUsers,
    unreadMessage,
    userReport,
    userReport,
    chooseTranslation,
    EmojiPicker,
    rightPanel,
    StickerPicker,
    GiftPicker,
    SendGiftModal,
    GiftPromptModal,
    emailDetailList,
    OperationGroup,
    MediaHistory,
  },
  data() {
    return {
      loading: false, // 添加loading状态
      cardList: [],
      isShowingPinnedMessages: false, // 当前是否显示收藏消息
      tools: [
        // { id: 0, url: require('@/assets/send.png'), name: '发送内容', width: 24, height: 20 },
        {
          id: 1,
          url: require('@/assets/link.png'),
          name: '附加文件',
          width: 21,
          height: 21,
        },
        // { id: 'sendFiles', url: require('@/assets/icon/sendFiles.png'), name: '发送文件', width: 24, height: 24 },
        // { id: 2, url: require('@/assets/MP4.png'), name: '发送语音', width: 16, height: 22 },
        // { id: 3, url: require('@/assets/eml.png'), name: '发送邮件', width: 20, height: 16 },
        {
          id: 5,
          url: require('@/assets/icon/post.png'),
          name: '帖子',
          width: 24,
          height: 24,
        },
        {
          id: 4,
          url: require('@/assets/fyIcon.png'),
          name: '翻译',
          width: 24,
          height: 24,
        },
      ],
      dropdownList: [
        {
          id: 0,
          name: '静音',
          name2: '取消静音',
          url: require('@/assets/unmute.png'),
          url2: require('@/assets/mute.png'),
        },
        // { id: 1, name: '闪烁', url: require('@/assets/flicker.png') },
        // { id: 2, name: '喜欢', url: require('@/assets/heart.png') },
      ],

      coverIndex: 0,
      message: '',

      editorContent: '',
      chatUserInfo: {}, // 聊天对象信息
      emojis: [],
      emojisList: [],
      tabKeyList: [],
      stickersList: [],
      giftTabIndex: '0', // 礼物tab索引
      theGiftList: [],
      tabTheGiftList: [],
      showEmojis: false,
      RecordingShow: false, // 录音弹窗
      messageInfoLoadingShow: true, // 聊天记录加载
      historyParams: {
        // criteria: [], // active：活跃会话，bookmarked：收藏会话，vip：会员会话，unanswered：待回复，''：全部会话
        cursor: '', // 将上次请求的cursor传入下次请求以作为分页依据
        limit: 15,
        offset: 0,
      },

      historyList: [], // 历史对话列表
      historyTotal: 0, // 历史对话总数
      sw: null, // websocket对象
      loadingImgShow: true, // 加载更多
      isHistoryLoading: false, // 历史记录加载状态
      chatMessageList: [], // 聊天记录

      emailShow: false, // 发送邮件弹窗
      coverList: [], // 邮件封面列表
      fristClick: false, // 是否第一次点击
      total: 0, // 聊天记录总数
      ossId: '', // 当前语音存储id
      tabStickersList: [],
      audioUrl: '', // 录音文件地址

      loadingFlag: false, // 判断是否重新加载 , 重新加载时,需要滚动条在最底部

      emailType: 1, // 邮件类型 1:发送邮件 2:邀请邮件
      emailFileFlag: false, // 邮件文件上传标志
      emailFileList: [], // 附件列表
      tabTheMsgList: ['历史', '团队', '个人'], //消息类型
      isQMsgTab: 0, //用户选择的快捷消息分类
      qMsgDataList: [],
      qMsgShow: false,
      createQMsgTypeShow: false,
      userReportShow: false, //举报窗口
      emojisKey: '', //emoji选择的是哪个数据
      translatedText: '',
      isTranslated: false,
      translatedBefore: '',
      isRecording: false, // 是否正在录音
      recordInterval: null, // 录音定时器
      recordTime: 0, // 录音时间
      createAudioUrl: false, // 录音生成中
      onlineQueryTimer: null, // 在线状态查询定时器
      // 请求取消控制器 Map，用于取消正在进行的请求
      abortControllers: new Map(), // key: 请求类型, value: AbortController

      userInfoIsOnline: false, // 用户信息中是否在线，自己默认在线，他人取值
      isHistoryMore: true, // 历史消息是否还有更多
      isChatMessageMore: true, // 聊天消息记录是否还有更多
      isPinnedMessageMore: true, // 收藏消息是否还有更多
      isRefreshing: false, // 是否是刷新
      sendFailDialogShow: false, // 发送失败弹窗显示状态
      failMsg: '', // 发送失败的消息内容
      // 拖拽相关
      leftWidth: 22, // 左侧宽度百分比
      centerWidth: 53, // 中间宽度百分比
      rightWidth: 25, // 右侧宽度百分比
      isDragging: false, // 是否正在拖拽
      dragType: '', // 拖拽类型：left 或 right
      startX: 0, // 拖拽开始的X坐标
      startLeftWidth: 0, // 拖拽开始时左侧宽度
      startCenterWidth: 0, // 拖拽开始时中间宽度
      startRightWidth: 0, // 拖拽开始时右侧宽度
      datingEmailLoading: false, // dating邮件加载状态
      userInfoId: '', // 当前查看用户信息的id
      emailLimit: 0,
      canSendWithoutLimit: false,
      giftLimit: 0,
      messageLimit: 0,
      isAvailable: false, //是否可以发送
      canSend: false, //是否可以发送礼物
      currentMessageType: 'chat', //消息类型 chat:聊天 email:邮件
      historyObserver: null, // 历史记录观察者实例

      emailUploadedFiles: [], // 邮件附件列表

      userMood: '', // 用户心情
      emailId: '', // 当前对话的邮箱id
      // 礼物发送弹窗相关
      sendGiftModalVisible: false, // 礼物发送弹窗显示状态
      selectedGift: null, // 选中的礼物
      // 礼物提示弹窗相关
      giftPromptModalVisible: false, // 礼物提示弹窗显示状态
      canSendPosts: false, // 用户是否有发posts权限
      urgentCheckTimer: null, // 紧急提醒检查定时器
      messageListenerRegistered: false, // 消息监听器是否已注册
      messageListenerCallback: null, // 消息监听器回调
      systemMessageLoading: false, // 系统消息加载状态加载完成后再显示空消息占位还是有系统消息
      historyRefreshTimer: null, // 历史记录自动刷新定时器
    };
  },
  computed: {
    limitStatus() {
      const status = [];

      // 消息状态
      const messageAvailable = this.messageLimit > 0;
      status.push({
        type: 'message',
        content: '消息',
        text: messageAvailable ? `${this.messageLimit}` : '0',
        available: messageAvailable,
      });

      // 邮件状态
      const emailAvailable = this.emailLimit > 0;
      status.push({
        type: 'email',
        content: '邮件',
        text: emailAvailable ? `${this.emailLimit}` : '0',
        available: emailAvailable,
      });

      // 状态(未知)
      status.push({
        type: '',
        content: '',
        text: 'available',
        available: this.isAvailable,
      });

      return status;
    },
    // 检查是否有发送失败的消息
    hasFailedMessages() {
      return this.chatMessageList.some((item) => item.messageStatus === 2);
    },
    // 当前选中的礼物列表
    currentGiftList() {
      const categoryName = this.tabTheGiftList[parseInt(this.giftTabIndex)];
      if (categoryName && this.theGiftList[categoryName]) {
        return this.theGiftList[categoryName].map((item) => ({
          ...item,
          url: item.referenceUrl || item.imageSrc,
          cost: item.cost,
          disabled: item.disabled || false,
        }));
      }
      return [];
    },
    canSendMessage() {
      return this.messageLimit > 0;
    },
    // 根据消息类型过滤工具列表
    filteredTools() {
      if (this.currentMessageType === 'email') {
        // 在邮件模式下隐藏帖子功能
        return this.tools.filter((item) => item.name !== '帖子');
      }
      return this.tools;
    },
    // 检查是否有超过5分钟未回复的消息
    hasOver5MinutesUnreplied() {
      if (!this.chatMessageList || this.chatMessageList.length === 0) {
        return false;
      }

      // 如果是邮件消息或收藏消息，不显示提醒
      if (this.currentMessageType === 'email' || this.isShowingPinnedMessages) {
        return false;
      }

      // 获取最新的消息（最后一条消息）
      const latestMessage =
        this.chatMessageList[this.chatMessageList.length - 1];

      const lastMessageType = latestMessage.type || latestMessage.messageType;

      // 检查是否为点赞或wink消息，如果是则不需要提醒
      const isLikeMessage =
        lastMessageType &&
        (lastMessageType.indexOf('like') !== -1 ||
          lastMessageType.indexOf('wink') !== -1);

      // 如果是点赞或wink消息，不显示紧急提醒
      if (isLikeMessage) {
        return false;
      }

      // 如果最新消息是对方发送的，检查是否超过5分钟
      if (
        latestMessage &&
        latestMessage.idUserFrom == this.chatUserInfo.userId
      ) {
        const messageDate = new Date(latestMessage.dateCreated);
        const now = new Date();
        const diffMinutes = (now - messageDate) / (1000 * 60);
        return diffMinutes > 5;
      }

      return false;
    },
    canSendGift() {
      if (this.canSendWithoutLimit) {
        return true;
      }
      if (this.canSendWithoutLimit == false && this.giftLimit > 0) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    historyList: {
      handler(newVal) {
        if (newVal.length > 0) {
          this.updateOnlineStatus();
        }
      },
    },
  },
  methods: {
    // 切换消息类型
    switchMessageType(type) {
      if (this.currentMessageType === type) {
        return; // 如果已经是当前类型，不需要切换
      }

      this.currentMessageType = type;

      // 清空相关数据
      this.chatMessageList = [];
      this.$refs.emailDetailListDom?.clearEmailList();

      // 根据切换的类型刷新数据
      if (type === 'email') {
        // 切换到邮件模式时，刷新邮件列表
        this.$nextTick(() => {
          this.$refs.emailDetailListDom?.refreshEmailList?.();
        });
      } else {
        // 切换到聊天模式时，重新获取聊天消息列表
        if (this.chatUserInfo && this.chatUserInfo.userId) {
          this.chatPageNum = 1; // 重置页码
          this.fristClick = true; // 重置是否第一次点击
          // 根据当前状态获取相应的消息
          if (this.isShowingPinnedMessages) {
            this.getPinnedMessages(0, this.chatUserInfo.userId).then((res) => {
              this.scrollToBottom();
            });
          } else {
            this.getChatList(0, this.chatUserInfo.userId).then((res) => {
              this.scrollToBottom();
            });
          }
        }
      }

      // 清空输入框和附件
      this.clearMessageInput();
      this.clearEmailFiles();
    },

    // 切换消息类型（在消息和邮件之间切换）
    toggleMessageType() {
      const newType = this.currentMessageType === 'chat' ? 'email' : 'chat';
      this.switchMessageType(newType);
      this.getEmailAndMessageCountFun();
    },

    updateOnlineStatus() {
      if (this.onlineQueryTimer) {
        clearTimeout(this.onlineQueryTimer);
        this.onlineQueryTimer = null;
      }
      let ids = this.historyList.map((item) => item.idInterlocutor);
      if (ids.length === 0) return;

      getOnlineStatus({ ids }).then((res) => {
        this.historyList.forEach((item) => {
          let is_online = res[item.idInterlocutor]
            ? res[item.idInterlocutor]
            : false;
          if (item.userDetail) {
            item.userDetail.is_online = is_online;
          } else {
            item.userDetail = {
              is_online,
            };
          }
        });
      }).catch((error) => {
        // 如果是 PD服务器请求失败: ConnectException: Connection timed out 错误，静默处理，不显示错误提示
        if (error && error.msg && error.msg.includes('PD服务器请求失败') && error.msg.includes('Connection timed out')) {
          console.log('在线状态查询失败（连接超时），静默处理');
          return;
        }
        // 其他错误也静默处理，在线状态查询失败不应该影响用户体验
        console.log('在线状态查询失败，静默处理:', error);
      });
      this.onlineQueryTimer = setTimeout(() => {
        this.updateOnlineStatus();
      }, 60000);
    },
    // 举报窗口
    userReportClose(v) {
      console.log(v.userId, this.historyList);
      this.historyList = this.historyList.filter(
        (item) => item.userId !== v.userId
      );
      this.$refs.unreadMessageDom.filterReportedUsers(v.userId);
      this.userReportShow = false;
      this.chatUserInfo.platformUserId = '';
    },
    // 过滤html标签
    handlePaste(e) {
      e.preventDefault(); // 阻止默认粘贴行为
      const clipboardData = e.clipboardData || window.clipboardData;
      const pastedText = clipboardData.getData('text/plain'); // 获取纯文本
      // 对于 textarea，直接设置值
      const currentValue = this.message;
      const textArea = this.$refs.editor;
      const start = textArea.selectionStart;
      const end = textArea.selectionEnd;
      this.message =
        currentValue.substring(0, start) +
        pastedText +
        currentValue.substring(end);
      // 设置光标位置
      this.$nextTick(() => {
        textArea.selectionStart = textArea.selectionEnd =
          start + pastedText.length;
      });
    },
    // 刷新当前聊天的信息
    refreshFun() {
      console.log('执行了吗3');
      this.isRefreshing = true;
      this.historyParams = {
        idLast: 0,
        limit: 15,
      };
      // 根据当前选中的类型决定刷新哪种数据
      const currentType = this.$refs.rightPanelDom.historyValue;
      if (currentType == '1') {
        // 历史模式：刷新历史对话列表
        this.getHistoryList('new')
          .then(() => {
            console.log('历史列表刷新完成');
            this.$nextTick(() => {
              // 检查首次加载是否需要更多数据
              this.checkIfNeedMoreData();

              // 重新设置观察者
              const loadingImg = this.$refs.rightPanelDom.$refs.loadingImg;
              if (loadingImg && this.loadingImgShow) {
                // 如果已经有观察者，先断开
                if (this.historyObserver) {
                  this.historyObserver.disconnect();
                  this.historyObserver = null;
                }
                this.historyObserver = this.createObserver(
                  loadingImg,
                  'history'
                );
              }
            });
          })
          .finally(() => {
            this.isRefreshing = false;
            // 重置组件的加载状态
            if (this.$refs.rightPanelDom) {
              this.$refs.rightPanelDom.resetLoadingState();
            }
          });
      } else {
        // 所有资料模式：刷新所有用户数据
        if (this.$refs.rightPanelDom.$refs.allMyUsersDom) {
          this.$refs.rightPanelDom.$refs.allMyUsersDom.getuserlist('new');
          console.log('所有用户数据刷新完成');
        } else {
          console.log('allMyUsersDom 组件未找到');
        }
        this.isRefreshing = false;
        // 重置组件的加载状态
        if (this.$refs.rightPanelDom) {
          this.$refs.rightPanelDom.resetLoadingState();
        }
      }
    },
    qMsgCreateClose() {
      this.$refs.qMsgDropdown.hide();
      this.createQMsgTypeShow = false;
    },
    qMsgClose() {
      this.createQMsgTypeShow();
    },
    createQMsgTypeFun() {
      this.$refs.qMsgDropdown.hide();
      this.createQMsgTypeShow = true;
    },
    // 获取快捷消息信息
    getqMsgFun() {
      this.qMsgDataList = [];
      getConversationStarterList({
        idLast: 0,
        limit: 15,
      }).then((res) => {
        let data = res.data;
        if (data.length > 0) {
          this.qMsgDataList = data.map((item, index) => {
            // 当前点击项设为true，其他所有项设为false
            return {
              ...item,
              state: false,
            };
          });
        }
      });
    },
    theMsgTabClick(v, i) {
      this.qMsgDataList = [];
      this.isQMsgTab = i;
      console.log(v);
      this.getqMsgFun(v.recId);
    },
    checkQMsg(v) {
      this.message = v;
    },
    senQMsg(v) {
      this.message = v;
      this.itemClick(0);
    },
    editQMsgFun() {
      // if (this.tabTheMsgList.length > 0) {
      // 	this.$refs.qMsgDropdown.hide()
      // 	this.qMsgShow = true;
      // } else {
      // 	this.$message.error('请先创建组别')
      // }
      this.$refs.qMsgDropdown.hide();
      this.qMsgShow = true;
    },

    qMsgClose() {
      this.qMsgShow = false;
    },

    // 处理用户删除
    handleUserDeleted(userInfo) {
      this.getHistoryList('new');
      console.log('执行了吗2');
      this.chatUserInfo = '';
      this.sendFailDialogShow = false; // 关闭发送失败弹窗
      this.failMsg = ''; // 清空失败消息内容
    },
    createObserver(el, name) {
      // 参数验证
      if (!el) {
        console.warn('createObserver: 目标元素不存在');
        return null;
      }

      const options = {
        root: null, // 使用视口作为根
        rootMargin: '0px', // 无边距
        threshold: 0.1, // 当10%可见时触发
      };

      const observer = new IntersectionObserver((entries) => {
        const entry = entries[0];
        if (entry.isIntersecting) {
          // 如果元素可见，就是拉到底了，触发加载更多
          this.handleIntersection(name);
        }
      }, options);

      observer.observe(el);
      return observer; // 返回观察者实例，便于后续管理
    },

    // 处理元素可见性变化
    handleIntersection(name) {
      switch (name) {
        case 'history':
          this.loadMoreHistory();
          break;
        case 'messagesInfo':
          this.loadMoreMessages();
          break;
        case 'newMessage':
          this.loadMoreNewMessages();
          break;
        default:
          console.warn('未知的观察者类型:', name);
          break;
      }
    },

    // 加载更多历史对话
    loadMoreHistory() {
      console.log('isRefreshing:::::', this.isRefreshing);
      console.log('isHistoryLoading:::::', this.isHistoryLoading);
      console.log('isHistoryMore:::::', this.isHistoryMore);
      // 如果正在刷新，则不加载更多
      if (this.isRefreshing) {
        return;
      }
      // 防止重复加载
      if (this.isHistoryLoading) {
        return;
      }
      console.log('122123');
      // 检查是否已加载完所有数据
      if (!this.isHistoryMore) {
        this.loadingImgShow = false;
        return;
      }

      this.isHistoryLoading = true;
      console.log(this.chatMessageList, this.chatUserInfo);
      // return
      this.getHistoryList()
        .then(() => {
          console.log('执行了吗4');
          this.isHistoryLoading = false;

          // 检查数据加载完成后是否需要继续加载
          this.$nextTick(() => {
            this.checkIfNeedMoreData();
          });
        })
        .finally(() => {
          this.isHistoryLoading = false;
          // 重置组件的加载状态
          if (this.$refs.rightPanelDom) {
            this.$refs.rightPanelDom.resetLoadingState();
          }
        });
    },

    // 检查是否需要加载更多数据（解决首次加载数据不足问题）
    checkIfNeedMoreData() {
      const container = document.querySelector('#historyMessageList');
      console.log('container:::::', container);
      if (!container) return;

      const hasScrollbar = container.scrollHeight > container.clientHeight;
      // 如果没有滚动条且还有更多数据，继续加载
      if (!hasScrollbar && this.isHistoryMore && !this.isHistoryLoading) {
        // 数据不足以产生滚动条，继续加载
        this.loadMoreHistory();
      } else if (hasScrollbar) {
        // console.log('已产生滚动条，停止自动加载');
      } else if (!this.isHistoryMore) {
        // 所有数据已加载完毕
        this.loadingImgShow = false;
      }
    },

    async initSocket() {
      // 获取账号列表并创建Socket连接
      await this.$store.dispatch('accountList/fetchAccountList');
      this.$refs.newMessagePanel?.fetchLikeMessageTotal();
      this.initWebSocket();
      // this.messageListener();
    },
    async initWebSocket() {
      // 使用全局WebSocket管理器，避免重复创建连接
      if (!globalWebSocketManager.getConnectionState()) {
        console.log('全局WebSocket未连接，等待连接建立...');
        // 等待连接建立
        await new Promise((resolve) => {
          const checkConnection = () => {
            if (globalWebSocketManager.getConnectionState()) {
              resolve();
            } else {
              setTimeout(checkConnection, 100);
            }
          };
          checkConnection();
        });
      }

      // 避免重复添加消息监听器
      if (this.messageListenerRegistered) return;
      this.messageListenerRegistered = true;

      // 保存监听器引用，以便后续移除
      this.messageListenerCallback = (data) => {
        // 数据已经在全局WebSocket管理器中处理过，直接使用
        // 不需要再次JSON解析，因为data已经是处理后的对象

        // 通过 sseManager 处理 socket 消息，确保未读消息数量更新
        sseManager.handleSocketMessage(data);

        // 原有的消息处理逻辑
        this.handleSSEMessage(
          {
            event: 'message',
            data: data,
          },
          'Socket'
        );
      };

      // 注册到全局WebSocket管理器
      globalWebSocketManager.registerMessageHandler(
        'message-page',
        this.messageListenerCallback
      );

      // 保存连接引用，用于兼容性
      this.sw = globalWebSocketManager.getConnection();
    },
    // 注册SSE消息处理器
    messageListener() {
      // 注册消息处理器到全局SSE管理器
      sseManager.registerMessageHandler('messagePage', (data, event) => {
        this.handleSSEMessage(data.data || data);
      });
    },

    // 处理SSE消息
    handleSSEMessage(data, type = 'SSE') {
      switch (data.event) {
        case 'message':
          console.log(
            '+++++++++++++++++++收到' + type + '消息+++++++++++++++++++',
            data.id,
            data
          );
          if (data.data == '连接成功！') return;
          switch (data.data.messageType) {
            // 文本消息
            case 'message':
            // 贴纸
            case 'sticker':
            // 点赞帖子
            case 'like_newsfeed_post':
            // 眨眼
            case 'wink':
            // 点赞照片
            case 'likephoto':
            // 照片
            case 'photo':
              if (this.currentMessageType == 'chat') {
                this.handleNewMessage(data.data);
              }
              break;
            case 'email':
              if (this.currentMessageType == 'email') {
                this.handleEmailMessage(data.data);
              }
              // 更新store中匹配账号的未读邮件数
              // this.updateAccountUnreadCount(data.data.idUserTo);
              break;
            default:
              console.log('未知的消息类型:', data.data.messageType);
              // 未知消息类型，也尝试处理
              this.handleNewMessage(data.data);
          }
          this.refreshMessageList(data.data);
          break;
        default:
          console.log('未知的' + type + '消息:', data);
      }
    },
    // 处理新消息
    async handleNewMessage(data) {
      const platformUserId = this.chatUserInfo.platformUserId,
        userId = this.chatUserInfo.userId;

      // 确保数据类型一致，转换为字符串进行比较
      const dataIdUserFrom = String(data.idUserFrom);
      const dataIdUserTo = String(data.idUserTo);
      const strPlatformUserId = String(platformUserId);
      const strUserId = String(userId);
      console.log('dataIdUserFrom:::::', dataIdUserFrom);
      console.log('dataIdUserTo:::::', dataIdUserTo);
      console.log('strPlatformUserId:::::', strPlatformUserId);
      console.log('strUserId:::::', strUserId);
      if (
        data.idUserFrom &&
        data.idUserTo &&
        platformUserId &&
        userId &&
        ((dataIdUserFrom === strUserId && dataIdUserTo === strPlatformUserId) ||
          (dataIdUserFrom === strPlatformUserId && dataIdUserTo === strUserId))
      ) {
        this.addMessageToChatList({
          id: data.messageId,
          requestId: data.messageId,
          idUserFrom: data.idUserFrom,
          idUserTo: data.idUserTo,
          type: data.messageType || 'message',
          dateCreated: new Date(data.dateCreatedStr).getTime(),
          content: data.content,
          messageStatus: 1,
          status: '0',
        });
        this.messageLimit = 10; // 更新消息限制
        // 在当前聊天窗口收到的新消息，自动阅读
        await readMessage({
          idMessage: Number(data.messageId),
        });
        // 同步更新顶部消息tab的角标
        if (this.$refs.newMessagePanel) {
          this.$refs.newMessagePanel.updateUnreadCount(data.idUserFrom, 0);
        }
      } else {
        // // 将SSE数据转换为新消息列表格式
        // const newMessageItem = {
        //   ...data,
        //   message: data.content?.message || data.content,
        //   content: data.content, // 保持原始content结构
        //   requestId: data.messageId, // 确保key值存在
        //   id: data.messageId, // 确保id字段存在
        //   mailId: data.messageType === 'mail' ? Number(data.messageId) : undefined,
        //   type: 'newMessage',
        //   idInterlocutor: Number(data.idUserFrom),
        //   userId: Number(data.idUserFrom),
        //   idUser: Number(data.idUserTo),
        //   platformUserId: Number(data.idUserTo),
        //   is_online: false,
        //   platformUserDetail: {
        //     id: Number(data.idUserTo),
        //     thumbnailUrl: data.idUserAvatar,
        //     avatar_large: data.idUserAvatar,
        //     avatar_small: data.idUserAvatar,
        //     name: data.idUserName,
        //   },
        //   userDetail: {
        //     id: Number(data.idUserFrom),
        //     thumbnailUrl: data.idUserFromAvatar,
        //     avatar_small: data.idUserFromAvatar,
        //     avatar_large: data.idUserFromAvatar,
        //     name: data.idUserFromName,
        //     isVip: data.isVip || false,
        //     isUnmanagedVip: data.isUnmanagedVip || false,
        //     is_online: false,
        //   },
        //   dateCreatedStr: data.dateCreatedStr,
        //   messageType: data.messageType || 'message',
        //   messageId: data.messageId,
        //   unreadMessagesCount: (data.unreadMessagesCount || 0) + 1,
        //   isFavorite: data.isFavorite || 0,
        // };
        // // 检查是否已存在相同消息，避免重复添加
        // const existingIndex = this.newMessage.findIndex(item =>
        //   item.idUserFrom === data.idUserFrom
        // );
        // if (existingIndex === -1) {
        //   // 追加到左侧列表
        //   this.newMessage.unshift(newMessageItem);
        // } else {
        //   // 如果已存在，获取现有消息的unreadMessagesCount并加1
        //   const existingUnreadCount = this.newMessage[existingIndex].unreadMessagesCount || 0;
        //   newMessageItem.unreadMessagesCount = existingUnreadCount + 1;
        //   // 先删除现有消息，然后添加到第一位
        //   this.newMessage.splice(existingIndex, 1);
        //   this.newMessage.unshift(newMessageItem);
        // }
      }
    },
    // 处理邮件新消息
    handleEmailMessage(data) {
      console.log('handleEmailMessage:::::', data);

      // 检查是否有聊天用户信息
      if (!this.chatUserInfo || !this.chatUserInfo.userId) {
        console.log('没有聊天用户信息，跳过邮件处理');
        return;
      }

      // 检查邮件是否属于当前对话
      const currentUserId = this.chatUserInfo.userId;
      const platformUserId = this.chatUserInfo.platformUserId;

      // 确保数据类型一致，转换为字符串进行比较
      const dataIdUserFrom = String(data.idUserFrom);
      const dataIdUserTo = String(data.idUserTo);
      const strCurrentUserId = String(currentUserId);
      const strPlatformUserId = String(platformUserId);

      // 检查邮件是否属于当前对话（发送者或接收者是当前对话的参与者）
      const isRelevantEmail =
        data.idUserFrom &&
        data.idUserTo &&
        ((dataIdUserFrom === strCurrentUserId &&
          dataIdUserTo === strPlatformUserId) ||
          (dataIdUserFrom === strPlatformUserId &&
            dataIdUserTo === strCurrentUserId));

      if (!isRelevantEmail) {
        console.log('邮件不属于当前对话，跳过处理');
        return;
      }

      // 调用emailDetailList组件的refreshEmailList方法，直接刷新邮件列表
      if (this.$refs.emailDetailListDom) {
        this.$refs.emailDetailListDom.refreshEmailList();
        console.log('邮件列表已刷新');
      }

      // 更新邮件限制
      if (this.emailLimit > 0) {
        this.emailLimit -= 1;
      }
    },
    // 更新store中匹配账号的未读邮件数
    updateAccountUnreadCount(idUserTo) {
      // 获取store中的账号列表
      const accountList = store.state.accountList.accountList;

      if (!accountList || accountList.length === 0) {
        return;
      }

      // 邮件接收者应该是需要更新未读邮件数的账号
      const targetUserId = String(idUserTo);

      // 查找匹配的账号（根据id匹配）
      const matchedAccount = accountList.find(
        (account) => String(account.id) === targetUserId
      );

      if (matchedAccount) {
        // 更新该账号的未读邮件数（+1）
        const currentUnreadCount = matchedAccount.unreadCount || 0;
        store.commit('accountList/SET_ACCOUNT_UNREAD_COUNT', {
          accountId: matchedAccount.id,
          count: currentUnreadCount + 1,
        });
      }
    },
    // 收到消息后的处理方法，刷新消息列表
    refreshMessageList(data) {
      console.log('refreshMessageList:::::', data);
      // 刷新历史对话列表
      this.getHistoryList('new');

      this.$refs.newMessagePanel?.handleNewMessage(data);

      // 如果是礼物消息，重新获取礼物限制状态
      if (data.messageType && data.messageType.indexOf('gift') !== -1) {
        this.refreshGiftLimit();
      }

      // 播放提示音 - 根据消息类型分别控制
      const isLikeMessage =
        data.messageType.indexOf('like') !== -1 ||
        data.messageType.indexOf('wink') !== -1;
      this.playMessageSound(isLikeMessage);
    },

    // 处理发送消息状态
    handleSendMsg(chatData, flag) {
      // 发送成功后，更新消息限制
      if (flag == 'success') {
        // 通知子组件移除新消息列表中的消息
        this.$refs.newMessagePanel?.removeMessageByUserId(
          chatData.userId,
          chatData.platformUserId,
          this.currentMessageType
        );
        this.messageLimit -= 1;

        // 发送消息成功后，刷新礼物限制状态
        this.refreshGiftLimit();
      }
      this.chatMessageList.map((item, index) => {
        if (item.requestId == chatData.requestId) {
          if (flag == 'success') {
            // console.log('成功')
            // this.$refs.unreadMessageDom?.removeLi(this.chatUserInfo.userId);
            this.$set(this.chatMessageList[index], 'messageStatus', 1);
          } else {
            this.$set(this.chatMessageList[index], 'messageStatus', 2);
            this.sendMessageFail([chatData]);
          }
        }
      });
    },
    isPlayer() {
      if (!this.$store.state.sound.muted) {
        const audio = document.getElementById('audioAuto');
        if (audio) {
          audio.play();
        }
      }
    },
    // 根据消息类型播放提示音
    playMessageSound(isLikeMessage) {
      // 如果是点赞消息且点赞消息提示音未静音，则播放提示音
      if (isLikeMessage && !this.$store.state.sound.likeMessageMuted) {
        const audio = document.getElementById('audioAuto');
        if (audio) {
          audio.play();
        }
      }
      // 如果是新消息且新消息提示音未静音，则播放提示音
      else if (!isLikeMessage && !this.$store.state.sound.newMessageMuted) {
        const audio = document.getElementById('audioAuto');
        if (audio) {
          audio.play();
        }
      }
    },

    async getHistoryList(v) {
      // 如果是刷新操作（v === 'new'），则允许执行，否则检查loadingImgShow状态
      if (v !== 'new' && !this.loadingImgShow) return Promise.resolve();

      if (v == 'new') {
        this.historyParams = {
          cursor: '',
          limit: 15,
          offset: 0,
        };
        this.historyList = [];
      }
      // let res = await getChatDialogsByCriteria({
      //   criteria: [],
      //   cursor: '',
      //   limit: 15,
      //   offset: 0
      // });
      let res = await getDialogueList(this.historyParams);
      console.log('历史记录', res);
      if (res && res.code == 200) {
        let dialogs = res.data.dialogsInfos;
        // let ids = dialogs.map(item => item.idInterlocutor);
        // let isVipRes = await getUserIsVip(ids);
        // console.log('isVipRes:::::', isVipRes);
        // const historysWithUserInfo = await store.dispatch(
        //   'userInfo/matchChatListUserInfo',
        //   {
        //     chatList: dialogs,
        //   }
        // );
        // console.log('historysWithUserInfo', historysWithUserInfo);
        // 格式化后端数据
        const formatDialogs = dialogs.map((item) => {
          // const isVipItem = isVipRes[item.idInterlocutor] || {};
          return {
            ...item,
            platformUserId: item.idUser,
            userId: item.idInterlocutor,
            platformUserDetail: {
              id: item.idUser,
              avatar_large: item.pdUserAvatar,
              avatar_small: item.pdUserAvatar,
              name: item.pdUserName,
            },
            userDetail: {
              id: item.idInterlocutor,
              avatar_small: item.interlocutorAvatar,
              avatar_large: item.interlocutorAvatar,
              name: item.interlocutorName,
              isVip: item.isVip,
              isUnmanagedVip: item.isUnmanagedVip,
              last_visit: item.dateUpdated,
              is_online: false, // 初始化在线状态，后续通过API更新
            },
          };
        });

        // 检测并补充缺失的用户头像和昵称信息
        await this.supplementMissingHistoryUserInfo(formatDialogs);

        this.historyList = [...this.historyList, ...formatDialogs];
        this.historyParams = {
          cursor: res.data.cursor,
          limit: res.data.limit,
          offset: res.data.offset,
        };
        this.isHistoryMore =
          res.data.dialogsInfos.length >= this.historyParams.limit;
        return Promise.resolve(res);
      } else {
        return Promise.reject(res);
      }
    },

    // 静默刷新历史记录（不显示loading，不影响用户操作）
    async silentRefreshHistoryList() {
      // 检查右侧面板是否存在
      if (!this.$refs.rightPanelDom) {
        console.log('静默刷新跳过: rightPanelDom不存在');
        return;
      }

      // 检查当前是否在历史模式
      if (this.$refs.rightPanelDom.historyValue !== '1') {
        console.log('静默刷新跳过: 不在历史模式, historyValue=', this.$refs.rightPanelDom.historyValue);
        return;
      }

      // 如果正在手动刷新或加载，跳过静默刷新
      if (this.isRefreshing || this.isHistoryLoading) {
        console.log('静默刷新跳过: 正在刷新或加载中');
        return;
      }

      console.log('静默刷新历史记录 - 开始请求');
      // 根据当前历史记录的长度请求对应数量的数据
      const currentListLength = this.historyList ? this.historyList.length : 0;
      // 限制请求数量：最少15条，最多100条（避免请求过多数据）
      const requestLimit = Math.max(15, Math.min(currentListLength || 15, 100));
      console.log(`当前历史记录长度: ${currentListLength}, 请求数量: ${requestLimit}`);

      // 使用对应数量的参数获取最新数据
      const refreshParams = {
        cursor: '',
        limit: requestLimit,
        offset: 0,
      };

      let res;
      res = await getDialogueList(refreshParams).catch(error => {
        // 静默处理错误，不影响用户操作
        console.log('静默刷新历史记录失败:', error);
        return null;
      });

      if (res && res.code == 200) {
        const dialogs = res.data.dialogsInfos;

        // 格式化后端数据
        const formatDialogs = dialogs.map((item) => {
          return {
            ...item,
            platformUserId: item.idUser,
            userId: item.idInterlocutor,
            platformUserDetail: {
              id: item.idUser,
              avatar_large: item.pdUserAvatar,
              avatar_small: item.pdUserAvatar,
              name: item.pdUserName,
            },
            userDetail: {
              id: item.idInterlocutor,
              avatar_small: item.interlocutorAvatar,
              avatar_large: item.interlocutorAvatar,
              name: item.interlocutorName,
              isVip: item.isVip,
              isUnmanagedVip: item.isUnmanagedVip,
              last_visit: item.dateUpdated,
              is_online: false,
            },
          };
        });

        // 检测并补充缺失的用户头像和昵称信息
        await this.supplementMissingHistoryUserInfo(formatDialogs);

        // 处理顺序变化的情况：
        // 1. 服务端返回的数据按照最新排序（可能有顺序变化）
        // 2. 应该用服务端的新排序替换前端的前N条记录
        // 3. 对于不在返回数据中的已存在记录，保留在原位置（因为这些可能已经被排序到后面，还没加载）

        const updatedList = [];
        const processedKeys = new Set();

        // 第一步：按照服务端返回的顺序添加所有返回的数据（包括新记录和更新的记录）
        // 这样可以保证前N条记录的顺序与服务端一致，反映最新的排序变化
        formatDialogs.forEach(newItem => {
          const key = `${newItem.userId}_${newItem.platformUserId}`;
          updatedList.push(newItem);
          processedKeys.add(key);
        });

        // 第二步：添加不在返回数据中的已存在记录（保持原有顺序）
        // 这些记录可能是：
        // - 已经被排序到后面，还没有在返回数据中
        // - 或者已经被删除，但用户已加载的部分还保留着
        this.historyList.forEach(item => {
          const key = `${item.userId}_${item.platformUserId}`;
          if (!processedKeys.has(key)) {
            // 不在返回数据中，保留原有记录和位置
            updatedList.push(item);
          }
        });

        // 静默更新列表，不触发loading状态
        this.historyList.splice(0, this.historyList.length, ...updatedList);
        console.log(`静默刷新完成: 更新了${formatDialogs.length}条记录，总记录数${updatedList.length}`);
      }
    },

    // 检测并补充历史记录中缺失的用户头像和昵称信息
    async supplementMissingHistoryUserInfo(historyList) {
      if (!historyList || historyList.length === 0) return;

      // 收集需要补充信息的用户ID
      const needSupplementUserIds = [];
      const needSupplementPlatformUserIds = [];

      historyList.forEach((item) => {
        // 检查用户信息是否缺失头像或昵称
        if (item.userDetail) {
          const hasMissingUserInfo =
            !item.userDetail.avatar_small ||
            !item.userDetail.avatar_large ||
            !item.userDetail.name;
          if (hasMissingUserInfo && item.userDetail.id) {
            needSupplementUserIds.push(item.userDetail.id);
          }
        }
        // 检查平台用户信息是否缺失头像或昵称
        if (item.platformUserDetail) {
          const hasMissingPlatformUserInfo =
            !item.platformUserDetail.avatar_small ||
            !item.platformUserDetail.avatar_large ||
            !item.platformUserDetail.name;
          if (hasMissingPlatformUserInfo && item.platformUserDetail.id) {
            needSupplementPlatformUserIds.push(item.platformUserDetail.id);
          }
        }
      });

      // 合并所有需要查询的用户ID，去重
      const allUserIds = [
        ...new Set([
          ...needSupplementUserIds,
          ...needSupplementPlatformUserIds,
        ]),
      ];

      if (allUserIds.length === 0) return;

      try {
        console.log('历史记录检测到缺失用户信息，正在补充:', allUserIds);

        // 调用getConnectionsProfiles接口获取用户资料
        const res = await getConnectionsProfiles({ ids: allUserIds });
        console.log('查询到的用户信息：', res);
        if (
          res &&
          res.data &&
          res.data.profiles &&
          res.data.profiles.length > 0
        ) {
          // 创建用户资料映射表
          const userProfilesMap = {};
          res.data.profiles.forEach((profile) => {
            userProfilesMap[profile.id] = profile;
          });

          // 补充缺失的用户信息
          historyList.forEach((item) => {
            if (item.platformUserId == 117669204) {
              console.log('117669204 补充前：', item);
              console.log(
                '用户信息：',
                userProfilesMap,
                '查询到的用户信息：',
                userProfilesMap[item.platformUserDetail.id]
              );
            }
            // 补充用户信息
            if (
              item.userDetail &&
              item.userDetail.id &&
              userProfilesMap[item.userDetail.id]
            ) {
              const profile = userProfilesMap[item.userDetail.id];
              if (!item.userDetail.thumbnailUrl) {
                item.userDetail.thumbnailUrl = profile.personal.avatar_small;
              }
              if (!item.userDetail.avatar_small) {
                item.userDetail.avatar_small = profile.personal.avatar_small;
              }
              if (!item.userDetail.avatar_large) {
                item.userDetail.avatar_large = profile.personal.avatar_large;
              }
              if (!item.userDetail.name) {
                item.userDetail.name = profile.name;
              }
            }

            // 补充平台用户信息
            if (
              item.platformUserDetail &&
              item.platformUserDetail.id &&
              userProfilesMap[item.platformUserDetail.id]
            ) {
              const profile = userProfilesMap[item.platformUserDetail.id];
              if (!item.platformUserDetail.thumbnailUrl) {
                item.platformUserDetail.thumbnailUrl =
                  profile.personal.avatar_small;
              }
              if (!item.platformUserDetail.avatar_small) {
                item.platformUserDetail.avatar_small =
                  profile.personal.avatar_small;
              }
              if (!item.platformUserDetail.avatar_large) {
                item.platformUserDetail.avatar_large =
                  profile.personal.avatar_large;
              }
              if (!item.platformUserDetail.name) {
                item.platformUserDetail.name = profile.name;
              }
            }

            if (item.platformUserId == 117669204) {
              console.log('117669204 补充后：', item);
            }
          });

          console.log('历史记录用户信息补充完成');
        }
      } catch (error) {
        console.error('补充历史记录用户信息失败:', error);
      }
    },

    // 获取贴纸列表
    async getStickersList(signal) {
      Promise.all([
        getRecentStickers({
          idInterlocutor: Number(this.chatUserInfo.userId),
          limit: 10,
        }, { signal }),
        getStickers({
          idInterlocutor: Number(this.chatUserInfo.userId),
        }, { signal }),
      ])
        .then(([recentRes, stickersRes]) => {
          console.log(recentRes, 'recentRes');
          console.log(stickersRes, 'stickersRes');
          this.stickersList = [
            {
              name: 'lmyHistory',
              stickers: recentRes,
            },
            ...stickersRes.categories,
          ];
          // 你可以在这里处理两个接口的返回数据
        })
        .catch((err) => {
          if (err.name !== 'AbortError') {
            console.error('有请求失败', err);
          }
        });
    },
    // 获取礼物列表
    async getGiftList(signal) {
      getGiftList({
        limit: 30,
        cursor: '',
        idRegularUser: Number(this.chatUserInfo.userId),
      }, { signal }).then((res) => {
        console.log('礼物：', res.items);
        // 根据category的id将礼物进行分组
        const giftCategories = {};
        if (res.items && res.items.length > 0) {
          res.items.forEach((item) => {
            const categoryId = item.category.id;
            const categoryName = item.category.name;

            if (!giftCategories[categoryName]) {
              giftCategories[categoryName] = [];
            }

            // 添加礼物到对应分类，并添加必要的属性
            giftCategories[categoryName].push({
              ...item,
              reference: `gift:${item.id}`,
              referenceUrl: item.imageSrc,
              disabled: false, // 根据需要设置是否禁用
            });
          });
        }
        this.theGiftList = giftCategories;
        this.tabTheGiftList = Object.keys(giftCategories);
        if (this.tabTheGiftList.length > 0) {
          this.giftTabIndex = '0'; // 重置为第一个tab
        }

        console.log('分组后的礼物列表：', this.theGiftList);
      });
    },
    // 获取表情列表
    async getSmilesListPromise() {
      return new Promise(async (resolve, reject) => {
        let res = await getSmilesList({
          platformType: this.chatUserInfo.platformType,
          platformUserId: this.chatUserInfo.platformUserId,
          userId: this.chatUserInfo.userId,
        });
        if (res.smiles) {
          // console.log(res.smiles, '表情列表')
          this.tabKeyList = Object.keys(res.smiles); // 获取tab的key
          this.emojisList = res.smiles; // 表情列表
          // console.log('res.smiles[0]::::'+this.tabKeyList[0])
          this.emojisKey = this.tabKeyList[0];
          this.emojis = this.emojisList[this.tabKeyList[0]]; // 默认显示第一个tab的表情
          console.log('表情列表加载完毕::::', this.emojisList);
          resolve();
        } else {
          reject();
        }
      });
    },
    // 发送礼物
    theGiftsBtn(item) {
      console.log('item', item);
      if (item.disabled) {
        return;
      }

      this.selectedGift = {
        ...item,
      };

      // 隐藏礼物列表
      if (this.$refs.giftPicker) {
        this.$refs.giftPicker.$refs.dropdown &&
          this.$refs.giftPicker.$refs.dropdown.hide();
      }

      this.sendGiftModalVisible = true;
    },

    // 处理礼物发送（带个人消息）
    handleSendGiftWithMessage(data) {
      const { gift, message } = data;
      const requestId = generateUUID();
      const userId = this.chatUserInfo.userId;
      const platformUserId = this.chatUserInfo.platformUserId;

      // 使用 sendVirtualGift API 发送礼物和消息
      let giftParams = {
        idUserTo: userId,
        idGift: gift.id,
        message: message && message.trim() ? message.trim() : undefined,
      };

      sendVirtualGift(giftParams)
        .then((res) => {
          console.log('礼物发送成功:', res);

          // 添加礼物消息到聊天列表
          this.addMessageToChatList({
            dateCreated: new Date().getTime(),
            idUserFrom: this.chatUserInfo.platformUserId,
            idUserTo: this.chatUserInfo.userId,
            type: 'virtual_gift',
            content: {
              id: gift.id,
              imageSrc: gift.imageSrc,
              message: message && message.trim() ? message.trim() : undefined,
            },
            requestId,
          });

          // 关闭弹窗
          this.sendGiftModalVisible = false;
          this.selectedGift = null;

          // 刷新礼物列表和礼物限制状态
          this.getGiftList();
          this.refreshGiftLimit();
        })
        .catch((err) => {
          console.error('礼物发送失败:', err);
          this.$message.error('礼物发送失败，请重试');
        });
    },
    tabClick(key) {
      console.log('key,', key);
      this.emojisKey = key;
      this.emojis = this.emojisList[key];
    },

    handleGiftCategoryChange(categoryName, index) {
      this.giftTabIndex = String(index);
    },

    // 显示礼物提示弹窗
    showGiftPrompt() {
      this.giftPromptModalVisible = true;
    },

    // 处理礼物提示弹窗确认
    handleGiftPromptConfirm() {
      this.giftPromptModalVisible = false;
      // 触发礼物选择器
      if (this.$refs.giftPicker) {
        this.$refs.giftPicker.$refs.dropdown &&
          this.$refs.giftPicker.$refs.dropdown.show();
      }
    },

    // 取消所有正在进行的请求
    cancelAllRequests() {
      this.abortControllers.forEach((controller, key) => {
        if (controller && !controller.signal.aborted) {
          controller.abort();
        }
      });
      this.abortControllers.clear();
    },

    // 创建新的请求控制器
    createAbortController(requestType) {
      // 如果已存在该类型的控制器，先取消它
      if (this.abortControllers.has(requestType)) {
        const oldController = this.abortControllers.get(requestType);
        if (oldController && !oldController.signal.aborted) {
          oldController.abort();
        }
      }
      // 创建新的控制器
      const controller = new AbortController();
      this.abortControllers.set(requestType, controller);
      return controller;
    },

    // 点击历史对话(默认聊天)
    async clickHistory(item, currentMessageType = 'chat') {
      console.log('item', item);

      // 取消所有正在进行的请求
      this.cancelAllRequests();

      let userList = JSON.parse(localStorage.getItem('userTokens'));
      let activeUser = userList.find((i) => i.id == item.platformUserId);

      // 安全检查：确保找到了匹配的token
      if (!activeUser || !activeUser.pdToken) {
        console.error(
          '未找到匹配的pdToken，platformUserId:',
          item.platformUserId
        );
        this.$message.error('用户token信息不完整，请重新登录');
        return;
      }

      localStorage.setItem('activeUser', JSON.stringify(activeUser));
      // 全部旧消息清空
      this.$refs.emailDetailListDom?.clearEmailList();
      this.chatMessageList = []; // 清空聊天记录
      this.chatPageNum = 1; // 重置页码
      this.fristClick = true; // 重置是否第一次点击
      this.isChatMessageMore = true; // 重置聊天消息是否还有更多数据
      this.isPinnedMessageMore = true; // 重置收藏消息是否还有更多数据
      this.messageLimit = 0;
      this.emailLimit = 0;
      this.giftPromptModalVisible = false; // 重置礼物提示弹窗状态
      this.currentMessageType = currentMessageType;
      this.isShowingPinnedMessages = false; // 重置为显示普通聊天消息
      this.giftLimit = 0;
      this.canSendWithoutLimit = false;

      console.log('点击历史对话', item);
      // 如果不是阅读邮件消息，阅读对话
      if (item.messageType != 'readMail') {
        //  否则阅读消息
        const readChatController = this.createAbortController('readChat');
        readChat({
          idRegularUser: Number(item.userId),
        }, { signal: readChatController.signal }).then((res) => {
          console.log('点击阅读消息', res);
          // 通知子组件更新未读消息数量
          this.$refs.newMessagePanel?.updateUnreadCount(item.userId, 0);
        }).catch((err) => {
          if (err.name !== 'AbortError') {
            console.error('阅读消息失败:', err);
          }
        });
      }

      if (item.mailId) {
        this.currentMessageType = 'email';
      }
      if (this.currentMessageType == 'email') {
        this.chatUserInfo = {
          ...item,
          platformType: 'talkytimes',
        };
        if (item.mailId) {
          this.emailId = item.mailId;
        } else {
          const emailIdController = this.createAbortController('emailId');
          await this.getEmailId(item.idInterlocutor, emailIdController.signal);
        }
        const chatLimitController = this.createAbortController('chatLimit');
        this.getChatLimit(chatLimitController.signal);
        this.getEmailAndMessageCountFun();
      } else {
        this.systemMessageLoading = true; // 重置系统消息加载状态
        this.chatUserInfo = {
          ...item,
          platformType: 'talkytimes',
        };
        this.messageLimit = item.messagesLeft;
        // 提前调用 getChatLimit 和 getEmailId，不需要等待消息列表加载完成
        const chatLimitController = this.createAbortController('chatLimit');
        const emailIdController = this.createAbortController('emailId');
        const chatListController = this.createAbortController('chatList');

        this.getChatLimit(chatLimitController.signal);
        this.getEmailId(item.idInterlocutor, emailIdController.signal);
        this.getChatList(0, item.userId, chatListController.signal)
          .then((res) => {
            console.log('消息加载完成', res);
            if (res.messages.length > 0) {
              readMessage({
                idMessage: Number(res.messages[res.messages.length - 1].id),
              });
              // 同步更新顶部消息tab的角标
              if (this.$refs.newMessagePanel) {
                this.$refs.newMessagePanel.updateUnreadCount(item.userId, 0);
              }
            }
            this.scrollToBottom();
          })
          .catch((error) => {
            if (error.name !== 'AbortError') {
              console.error('获取聊天记录失败:', error);
            }
          })
          .finally(() => {
            this.afterGetChat(item.idInterlocutor);
          });
      }
      this.$nextTick(() => {
        const moodController = this.createAbortController('chatUserMood');
        this.getChatUserMood(item.idInterlocutor, moodController.signal);
      });
    },
    // 获取聊天信息后，获取其他信息
    afterGetChat(userId) {
      const profileController = this.createAbortController('profileByPairs');
      const stickersController = this.createAbortController('stickersList');
      const giftListController = this.createAbortController('giftList');
      const vipController = this.createAbortController('canSetVip');

      this.getProfileByPairs(userId, profileController.signal);
      this.getStickersList(stickersController.signal);
      this.getGiftList(giftListController.signal);
      this.getCanSetVip(vipController.signal);
      // this.getIPostsPermission();
    },
    // 获取邮件及信息数量
    getEmailAndMessageCountFun() {
      const emailLimitController = this.createAbortController('emailLimit');
      const messageCountController = this.createAbortController('messageCount');

      getEmailLimit({
        idRegularUser: this.chatUserInfo.userId,
      }, { signal: emailLimitController.signal }).then((res) => {
        console.log('邮件限制：', res);
        this.emailLimit = res.data.messagesLeft;
      }).catch((err) => {
        if (err.name !== 'AbortError') {
          console.error('获取邮件限制失败:', err);
        }
      });

      getChatDialogsByPairs({
        idsRegularUser: [Number(this.chatUserInfo.userId)],
      }, { signal: messageCountController.signal }).then((res) => {
        console.log('邮件及信息数量：', res);
        if (res.length > 0) {
          const item = res[0];
          if (
            item.idInterlocutor == this.chatUserInfo.userId &&
            item.idUser == this.chatUserInfo.platformUserId
          ) {
            this.$set(this.chatUserInfo, 'isBookmarked', item.isBookmarked);
            this.$set(this.chatUserInfo, 'isPinned', item.isPinned);
          }
          this.messageLimit = item.messagesLeft;
        } else {
          this.messageLimit = 0;
        }
      }).catch((err) => {
        if (err.name !== 'AbortError') {
          console.error('获取邮件及信息数量失败:', err);
        }
      });
    },
    // 查询单个用户与自己的状态
    getProfileByPairs(userId, signal) {
      getChatDialogsByPairs({
        idsRegularUser: [Number(userId)],
      }, { signal })
        .then((res) => {
          console.log('对方与自己的状态:::::::::::::', res);
          if (res.length > 0) {
            let item = res[0];
            // 确保还在当前对话
            if (
              item.idInterlocutor == this.chatUserInfo.userId &&
              item.idUser == this.chatUserInfo.platformUserId
            ) {
              this.$set(this.chatUserInfo, 'isBlocked', item.isBlocked);
              this.$set(this.chatUserInfo, 'isBookmarked', item.isBookmarked);
              this.$set(this.chatUserInfo, 'isPinned', item.isPinned);
              // 最后一条消息是否是系统消息
              if (item.lastMessage && item.lastMessage.type == 'system') {
                this.chatUserInfo.systemMessage = item.lastMessage;
              }
              // 更新消息限制
              this.chatUserInfo.messagesLeft = item.messagesLeft;
              this.messageLimit = item.messagesLeft;
            }
          } else {
            this.chatUserInfo.messagesLeft = 0;
            this.messageLimit = 0;
          }
        })
        .catch((err) => {
          if (err.name !== 'AbortError') {
            console.error('获取用户状态失败:', err);
          }
        })
        .finally(() => {
          this.systemMessageLoading = false;
        });
    },
    getCanSetVip(signal) {
      getFeatureFlagList({ signal }).then((res) => {
        this.$set(this.chatUserInfo, 'vipContacts', res.vipContacts);
      }).catch((err) => {
        if (err.name !== 'AbortError') {
          console.error('获取VIP设置失败:', err);
        }
      });
    },
    getEmailId(userId, signal) {
      getEmailId({
        idInterlocutor: userId,
      }, { signal }).then((res) => {
        // 当前对话的邮箱id
        const newEmailId = res.data.last?.id_correspondence;

        // 如果之前没有emailId，现在有了新的emailId，需要刷新邮件列表
        if (!this.emailId && newEmailId) {
          this.emailId = newEmailId;
          // 如果当前在邮件模式下，刷新邮件列表
          if (
            this.currentMessageType === 'email' &&
            this.$refs.emailDetailListDom
          ) {
            this.$nextTick(() => {
              this.$refs.emailDetailListDom?.refreshEmailList?.();
            });
          }
        } else {
          this.emailId = newEmailId;
        }
      });
    },
    // 获取用户是否有发posts权限
    getIPostsPermission() {
      getEmailPhotoForbiddenTags({
        idInterlocutor: this.chatUserInfo.userId,
      }).then((res) => {
        console.log('邮箱发图片的权限：', res);
        // ["special_plus"]
        if (res.includes('special_plus')) {
          console.log('用户没有发posts权限');
          this.canSendPosts = false;
        } else {
          console.log('用户有发posts权限');
          this.canSendPosts = true;
        }
      });
    },
    // 获取当前聊天用户的心情
    getChatUserMood(userId, signal) {
      console.log('userId:::::::::::::', userId);
      getConnectionsProfiles({ ids: [userId] }, { signal }).then((res) => {
        console.log(
          'talkytimes用户信息:::::::::::::',
          res.data.profiles[0].personal.mood
        );
        // 对面的心情，使用标签
        this.userMood = res.data.profiles[0].personal.mood;
        // mood: "friendship"
        // this.chatUserInfo.mood = res.data.profiles[0].mood
      });
    },
    // 刷新礼物限制状态
    refreshGiftLimit() {
      if (
        !this.chatUserInfo ||
        !this.chatUserInfo.userId ||
        !this.chatUserInfo.platformUserId
      ) {
        console.log('没有聊天用户信息，跳过礼物限制刷新');
        return;
      }

      console.log('刷新礼物限制状态');
      getGiftLimit({
        idUserFrom: this.chatUserInfo.platformUserId,
        idUserTo: this.chatUserInfo.userId,
      })
        .then((giftLimit) => {
          console.log('礼物限制更新：', giftLimit);
          this.giftLimit = giftLimit.limit;
          this.canSendWithoutLimit = giftLimit.canSendWithoutLimit;

          // 如果礼物限制发生变化，可以在这里添加相应的UI更新逻辑
          this.$nextTick(() => {
            if (this.canSendGift) {
              console.log('礼物限制已更新，当前可以发送礼物');
            }
          });
        })
        .catch((error) => {
          console.error('获取礼物限制失败:', error);
        });
    },
    getChatLimit(signal) {
      // getMessageLimit({
      // 	idUserTo: this.chatUserInfo.userId
      // }).then(res => {
      // 	console.log('消息限制：', res)
      // 	this.messageLimit = res.status;
      // })
      getEmailLimit({
        idRegularUser: this.chatUserInfo.userId,
      }, { signal }).then((res) => {
        console.log('邮件限制：', res);
        this.emailLimit = res.data.messagesLeft;
      }).catch((err) => {
        if (err.name !== 'AbortError') {
          console.error('获取聊天限制失败:', err);
        }
      });
      // 能否发送(未知)
      const presentAvailableController = this.createAbortController('presentIsAvailable');
      getPresentIsAvailable({ idRegularUser: this.chatUserInfo.userId }, { signal: presentAvailableController.signal }).then(
        (res) => {
          console.log('能否发送：', res);
          this.isAvailable = res.isAvailable;
        }
      ).catch((err) => {
        if (err.name !== 'AbortError') {
          console.error('获取发送状态失败:', err);
        }
      });

      const selectPostController = this.createAbortController('selectCanSendPost');
      selectCanSendPost({ pdUserId: this.chatUserInfo.platformUserId, userId: this.chatUserInfo.userId }, { signal: selectPostController.signal, cancelToken: null }).then(
        (res) => {
          console.log('能否发送post：', res);
          this.canSendPosts = res.data;
        }
      ).catch((err) => {
        if (err.name !== 'AbortError') {
          console.error('获取post权限失败:', err);
        }
      });

      const giftLimitController = this.createAbortController('giftLimit');
      const giftPromise = [
        // getGiftStatus({
        //   idUserTo: this.chatUserInfo.userId,
        // }),
        getGiftLimit({
          idUserFrom: this.chatUserInfo.platformUserId,
          idUserTo: this.chatUserInfo.userId,
        }, { signal: giftLimitController.signal }),
      ];
      // giftStatus,
      Promise.all(giftPromise).then(([giftLimit]) => {
        console.log('礼物限制：', giftLimit);
        // this.canSend = giftStatus.status == 'can_send' ? true : false;
        this.giftLimit = giftLimit.limit;
        this.canSendWithoutLimit = giftLimit.canSendWithoutLimit;
        // 如果之前不能发送礼物，现在可以发送了，显示提示弹窗
        this.$nextTick(() => {
          if (this.canSendGift) {
            // this.showGiftPrompt();
            this.$message.success('您可以向对方发送礼物');
          }
        });
      }).catch((err) => {
        if (err.name !== 'AbortError') {
          console.error('获取礼物限制失败:', err);
        }
      });
    },

    handleScroll: _.debounce(function (event) {
      const container = event.target;
      const scrollThreshold = 50;

      // 检查是否有消息列表
      if (!this.chatMessageList || this.chatMessageList.length === 0) {
        return;
      }

      // 检查是否有聊天用户信息
      if (!this.chatUserInfo || !this.chatUserInfo.userId) {
        return;
      }

      if (
        container.scrollTop <= scrollThreshold &&
        ((this.isShowingPinnedMessages && this.isPinnedMessageMore) ||
          (!this.isShowingPinnedMessages && this.isChatMessageMore)) &&
        !this.loading
      ) {
        // 记录当前第一个消息的 id 和 offsetTop（取组件 $el）
        const firstMsg = this.chatMessageList[0];
        const firstMsgId = firstMsg?.id || firstMsg?.requestId;
        let firstMsgComponent = this.$refs['msg-' + firstMsgId]?.[0];
        let firstMsgEl = firstMsgComponent ? firstMsgComponent.$el : null;
        const prevOffset = firstMsgEl ? firstMsgEl.offsetTop : 0;

        this.loading = true;
        this.chatPageNum++;
        const idLastMessage = firstMsgId;
        const idRegularUser = this.chatUserInfo.userId;
        if (!idLastMessage) {
          this.loading = false;
          return;
        }

        // 根据当前状态获取相应的消息
        if (this.isShowingPinnedMessages) {
          this.getPinnedMessages(idLastMessage, idRegularUser)
            .then((res) => {
              this.$nextTick(() => {
                let targetComponent = this.$refs['msg-' + firstMsgId]?.[0];
                let targetEl = targetComponent ? targetComponent.$el : null;
                const container = this.$refs.messageList;
                if (container && targetEl) {
                  container.scrollTop = targetEl.offsetTop - prevOffset;
                }
              });
            })
            .catch((error) => {
              this.chatPageNum--;
              this.loading = false;
            });
        } else {
          this.getChatList(idLastMessage, idRegularUser)
            .then((res) => {
              this.$nextTick(() => {
                let targetComponent = this.$refs['msg-' + firstMsgId]?.[0];
                let targetEl = targetComponent ? targetComponent.$el : null;
                const container = this.$refs.messageList;
                if (container && targetEl) {
                  container.scrollTop = targetEl.offsetTop - prevOffset;
                }
              });
            })
            .catch((error) => {
              this.chatPageNum--;
              this.loading = false;
            });
        }
      }
    }, 300),
    loadMoreMessages() {
      if (this.loading) return;
      this.loading = true;
      this.chatPageNum++;

      // 根据当前状态获取相应的消息
      if (this.isShowingPinnedMessages) {
        this.getPinnedMessages(0, this.chatUserInfo.userId);
      } else {
        this.getChatList(0, this.chatUserInfo.userId);
      }
    },
    findEmojiByNameWithCategory(data, name) {
      for (const category in data) {
        const matched = data[category].find((item) => item.Name === name);
        if (matched) {
          return { category, emoji: matched };
        }
      }
      return null;
    },
    // 用户发送消息，添加消息到聊天列表
    addMessageToChatList(messageData = {}) {
      const timestamp = messageData.msgTimestamp;
      const requestId = messageData.requestId;

      const completeMessage = {
        requestId,
        recipient: this.chatUserInfo.platformUserId,
        sender: this.chatUserInfo.platformUserId,
        msgTimestamp: timestamp,
        messageStatus: 0,
        status: '0',
        isRead: 1,
        msgFiles: [],
        ...messageData, // 用户传入的数据会覆盖默认值
      };

      this.chatMessageList.push(completeMessage);

      this.scrollToBottom();
    },

    // 获取聊天记录
    getChatList(idLastMessage, idRegularUser, signal) {
      return new Promise(async (resolve, reject) => {
        this.loading = true; // 开始加载
        let params = {
          idLastMessage: idLastMessage, // 上一条消息id
          idRegularUser: idRegularUser, // 聊天对象id
          limit: this.historyParams.limit,
        };
        getChatMessages(params, { signal })
          .then((res) => {
            console.log('聊天信息：', res);
            if (idLastMessage) {
              this.chatMessageList = [...res.messages, ...this.chatMessageList];
            } else {
              this.chatMessageList = res.messages || [];
            }

            this.isChatMessageMore =
              res.messages && res.messages.length >= params.limit;
            resolve(res);
          })
          .catch((error) => {
            if (error.name !== 'AbortError') {
              console.error('获取聊天记录失败：', error);
              this.chatMessageList = [];
              reject(error);
            }
          })
          .finally(() => {
            this.loading = false; // 结束加载
          });
      });
    },

    // 获取收藏的消息
    getPinnedMessages(idLastMessage, idRegularUser) {
      return new Promise(async (resolve, reject) => {
        this.loading = true; // 开始加载
        let params = {
          idLastMessage: idLastMessage, // 上一条消息id
          idRegularUser: idRegularUser, // 聊天对象id
          limit: this.historyParams.limit,
        };
        getPinnedMessages(params)
          .then((res) => {
            console.log('收藏消息信息：', res);
            if (idLastMessage) {
              this.chatMessageList = [...res.messages, ...this.chatMessageList];
            } else {
              this.chatMessageList = res.messages || [];
            }

            this.isPinnedMessageMore =
              res.messages && res.messages.length >= params.limit;
            resolve(res);
          })
          .catch((error) => {
            console.error('获取收藏消息失败：', error);
            this.chatMessageList = [];
            reject(error);
          })
          .finally(() => {
            this.loading = false; // 结束加载
          });
      });
    },
    scrollToBottom() {
      this.$nextTick(() => {
        if (this.$refs.messageList) {
          this.$refs.messageList.scrollTop =
            this.$refs.messageList.scrollHeight;
        }
      });
    },
    // 点击新消息聊天
    async clickNewMessage(item) {
      console.log('点击新消息：：：', item);

      item.userId = item.idUserFrom;
      let type = '';
      switch (item.messageType) {
        case 'chat':
          type = 'chat';
          break;
        case 'mail':
          type = 'email';
          break;
        case 'reaMail':
        case 'readMail':
          type = 'email';
          // 注释掉自动移除消息的逻辑，点击不再移除消息
          this.$nextTick(() => {
            this.$refs.newMessagePanel?.closeNoticeMessage(item);
          });
          break;
        case 'platform_CorrespondenceLimitChanged':
          type = 'email';
          // 注释掉自动移除消息的逻辑，点击不再移除消息
          // this.$nextTick(() => {
          //   this.$refs.newMessagePanel?.closeMessage(item);
          // });
          break;
        case 'giftLimit':
          type = 'chat';
          // this.$nextTick(() => {
          //   this.$refs.newMessagePanel?.closeNoticeMessage(item);
          // });
          break;
        default:
          type = 'chat';
          break;
      }
      this.clickHistory(item, type);
    },
    // 关闭新消息
    close(item) {
      console.log('消息类型', item);
      // 通知子组件处理关闭逻辑
      this.$refs.newMessagePanel?.closeMessage(item);
    },

    // 处理查看收藏的消息
    handleViewPinnedMessages(userId) {
      console.log('切换消息类型，用户ID:', userId);
      // 清空当前消息列表
      this.chatMessageList = [];

      // 重置查询相关状态
      this.isChatMessageMore = true; // 重置聊天消息是否还有更多数据
      this.isPinnedMessageMore = true; // 重置收藏消息是否还有更多数据
      this.loading = false; // 重置加载状态
      this.chatPageNum = 1; // 重置页码（如果存在）
      this.fristClick = true; // 重置是否第一次点击

      if (this.isShowingPinnedMessages) {
        // 当前显示收藏消息，切换到普通聊天消息
        this.isShowingPinnedMessages = false;
        this.getChatList(0, userId).then(() => {
          this.scrollToBottom();
        });
      } else {
        // 当前显示普通聊天消息，切换到收藏消息
        this.isShowingPinnedMessages = true;
        this.getPinnedMessages(0, userId).then(() => {
          this.scrollToBottom();
        });
      }
    },

    // 处理查看媒体历史
    handleViewMediaHistory(userId) {
      console.log('查看媒体历史，用户ID:', userId);
      // 调用媒体历史组件的初始化方法
      this.$refs.mediaHistory.init(userId);
    },
    async itemClick(id) {
      console.log('操作类型ID:', id);
      // return
      this.emailFileList = [];

      // 发送入口权限判断， id == 5 || id === '5' ||
      if (this.tools.find((t) => t.id == id)?.name === '礼物') {
        // 礼物
        if (!this.canSendGift) {
          this.$message.warning('无权限发送礼物');
          return;
        }
        if (this.giftLimit == 0) {
          this.$message.success('您无法向对方发送礼物');
          return;
        }
      } else {
        // 其他
        if (!this.canSendMessage && this.currentMessageType === 'chat') {
          this.$message.warning('消息不足');
          return;
        } else if (this.currentMessageType === 'email') {
          // 邮件模式下的权限检查
          // if (id === 1 || id === '1') {
          //   // 附件功能，如果邮件数量充足，允许用户选择媒体库
          //   if (this.emailLimit <= 0) {
          //     this.$message.warning('邮件数量不足');
          //     return;
          //   }
          // } else if (this.emailLimit <= 0) {
          //   // 其他功能需要邮件数量充足
          //   this.$message.warning('邮件数量不足');
          //   return;
          // }
        }
      }
      // console.log('this.currentMessageType::::::', this.currentMessageType);
      // return;
      switch (id) {
        case 0:
        case '0':
          await this.handleSendMessage(); // 发送消息
          break;
        case 1:
        case '1':
          this.handleAttachment(false); // 附件
          break;
        case 2:
        case '2':
          await this.handleVoiceRecord(); // 语音录制
          break;
        case 3:
        case '3':
          this.handleSendEmail(); // 发送邮件
          break;
        case 4:
        case '4':
          break;
        case 5:
        case '5':
          // this.handleAttachment(true); // 邮件附件
          console.log(this.chatUserInfo, 'this.chatUserInfo');
          this.$router.push({
            path: '/talkytimes/postView',
            query: {
              platformUserId: this.chatUserInfo.platformUserId,
              idInterlocutor: this.chatUserInfo.idInterlocutor,
              from: 'message', // 添加来源标识
            },
          });
          break;
        case 'sendFiles':
          console.log('发送文件');
          break;
        default:
          console.warn('未知的操作类型:', id);
      }
    },

    // 处理发送消息
    async handleSendMessage() {
      if (this.currentMessageType === 'email') {
        // 检查邮件可用状态
        const emailAvailable = this.emailLimit > 0;
        if (!emailAvailable) {
          this.$message.warning('邮件数量不足，无法发送邮件');
          return;
        }

        if (!this.message) {
          this.$message({
            message: '请输入邮件内容',
            type: 'warning',
          });
          return;
        }

        if (this.message.length < 150) {
          this.$message.warning(
            `邮件内容至少需要150个字符，当前只有${this.message.length}个字符`
          );
          return;
        }

        // 根据API格式构建数据
        const emailData = {
          content: this.message,
          idUserTo: this.chatUserInfo.userId || 0, // 收件人用户ID
          vip: this.chatUserInfo.userDetail.isVip,
          images: this.emailUploadedFiles
            .filter(
              (file) =>
                file.type === 'image' ||
                (file.type && file.type.startsWith('image'))
            )
            .map((file) => ({
              idPhoto: file.id || parseInt(file.name.match(/\d+/)?.[0] || 0),
            })),
          videos: this.emailUploadedFiles
            .filter(
              (file) =>
                file.type === 'video' ||
                (file.type && file.type.startsWith('video'))
            )
            .map((file) => ({
              idVideo: file.id || parseInt(file.name.match(/\d+/)?.[0] || 0),
            })),
        };
        // 生成请求ID
        const requestId = generateUUID();
        const userId = this.chatUserInfo.userId;
        const platformUserId = this.chatUserInfo.platformUserId;

        try {
          // 发送邮件
          const response = await sendLetter(emailData);

          this.$message.success('邮件发送成功');

          // 调用handleSendMsg处理发送成功状态
          this.handleSendMsg({ requestId, userId, platformUserId }, 'success');

          // 更新邮件限制计数
          this.emailLimit -= 1;

          // 构建发送的邮件数据，添加到邮件列表
          const sentEmailData = {
            id: response?.data?.id || Date.now(), // 使用返回的邮件ID或生成临时ID
            id_user_from: this.chatUserInfo.platformUserId,
            id_user_to: this.chatUserInfo.userId,
            content: this.message,
            date_created: new Date().toISOString(),
            attachments: {
              images: this.emailUploadedFiles
                .filter(
                  (file) =>
                    file.type === 'image' ||
                    (file.type && file.type.startsWith('image'))
                )
                .map((file) => ({
                  id: file.id || parseInt(file.name.match(/\d+/)?.[0] || 0),
                  url_thumbnail: file.url,
                  url_original: file.url,
                  is_paid: false, // 发送邮件的附件默认未读
                })),
              videos: this.emailUploadedFiles
                .filter(
                  (file) =>
                    file.type === 'video' ||
                    (file.type && file.type.startsWith('video'))
                )
                .map((file) => ({
                  id: file.id || parseInt(file.name.match(/\d+/)?.[0] || 0),
                  url_thumbnail: file.url,
                  url_original: file.url,
                  is_paid: false, // 发送邮件的附件默认未读
                })),
            },
          };

          // 重新获取邮箱ID，因为现在有了邮件往来
          if (!this.emailId) {
            this.getEmailId(this.chatUserInfo.userId);
          }

          // 将发送的邮件添加到邮件列表
          if (this.$refs.emailDetailListDom) {
            this.$refs.emailDetailListDom.addNewEmail(sentEmailData);
            console.log('发送的邮件已添加到邮件列表');
          }

          // 清空输入框和附件
          this.clearMessageInput();
          this.clearEmailFiles();

          // 发送后从新消息列表中移除
          this.$refs.newMessagePanel?.removeMessageByUserId(
            this.chatUserInfo.userId,
            this.chatUserInfo.platformUserId,
            this.currentMessageType
          );
        } catch (error) {
          console.error('邮件发送失败:', error);
          this.$message.error('邮件发送失败，请重试');

          // 调用handleSendMsg处理发送失败状态
          this.handleSendMsg(
            {
              requestId,
              api: sendLetter,
              params: emailData,
              userId,
              platformUserId,
            },
            'error'
          );

          // 发送失败时不添加到邮件列表，不清空输入框
          return;
        }
      } else {
        // 检查消息可用状态
        const messageAvailable = this.messageLimit > 0;
        if (!messageAvailable) {
          this.$message.warning('消息数量不足，无法发送消息');
          return;
        }

        if (!this.message) {
          this.$message({
            message: '请输入消息',
            type: 'warning',
          });
          return;
        }

        const requestId = generateUUID();
        const userId = this.chatUserInfo.userId;
        const platformUserId = this.chatUserInfo.platformUserId;
        let params = {
          message: this.message,
          idRegularUser: userId,
          vip: this.chatUserInfo.userDetail.isVip,
        };
        console.log('发送消息::::::', params);
        sendText(params)
          .then((res) => {
            console.log('发送成功:', res);
            if (res.idMessage) {
              this.handleSendMsg(
                { requestId, userId, platformUserId },
                'success'
              );
            } else {
              if (res.error == 'Request not satisfied VIP requirements') {
                this.failMsg = '对方不满足VIP条件';
              } else {
                this.failMsg = res.error;
              }
              this.sendFailDialogShow = true;
              this.handleSendMsg(
                { requestId, api: sendText, params, userId, platformUserId },
                'error'
              );
            }
          })
          .catch((err) => {
            console.error('发送失败:', err);
            if (err.error == 'Request not satisfied VIP requirements') {
              this.failMsg = '对方不满足VIP条件';
            } else {
              this.failMsg = err.error;
            }
            this.sendFailDialogShow = true;
            this.handleSendMsg(
              { requestId, api: sendText, params, userId, platformUserId },
              'error'
            );
          })
          .finally(() => {
            this.getHistoryList();
          });

        this.addMessageToChatList({
          type: 'message',
          idUserFrom: this.chatUserInfo.platformUserId,
          idUserTo: this.chatUserInfo.userId,
          requestId: requestId,
          dateCreated: new Date().getTime(),
          content: {
            message: this.message,
          },
        });

        // 清空输入框
        this.clearMessageInput();

        // 发送后从新消息列表中移除
        this.$refs.newMessagePanel?.removeMessageByUserId(
          this.chatUserInfo.userId,
          this.chatUserInfo.platformUserId,
          this.currentMessageType
        );
      }
    },

    // 处理附件上传
    handleAttachment(isEmailAttachment = false) {
      this.emailFileFlag = isEmailAttachment;
      this.$refs.attachmentDom.init();
    },

    // 处理语音录制
    async handleVoiceRecord() {
      try {
        const hasPermission = await recorder.getPermission();
        if (hasPermission) {
          this.RecordingShow = true;
        } else {
          this.$message.error('无法获取麦克风权限');
        }
      } catch (error) {
        console.error('获取录音权限失败:', error);
        this.$message.error('无法启动录音功能');
      }
    },

    // 处理发送邮件
    handleSendEmail() {
      this.emailShow = true;
      this.emailType = 1;
      this.generatingEmail();
    },

    // 清空消息输入框
    clearMessageInput() {
      this.message = '';
      // 重置翻译状态
      if (this.$refs.chooseTra?.[0]) {
        this.$refs.chooseTra[0].isTranslated = false;
      }
    },
    // 同步输入框和敏感词高亮层的滚动
    handleInputScroll() {
      if (this.$refs.editor && this.$refs.highlightOverlay) {
        this.$refs.highlightOverlay.scrollTop = this.$refs.editor.scrollTop;
      }
    },
    generatingEmail() {
      this.datingEmailLoading = true;
      // TODO: 使用新版 talkytimes 接口替代
      console.warn('generateEmailContent 旧版接口已移除，需要使用新版接口');
    },
    sendEmailFn(data) {
      const dataInfo = JSON.parse(data);
      // TODO: 使用新版 talkytimes 接口替代
      console.warn('sendEmailMessage 旧版接口已移除，需要使用新版接口');
      this.emailShow = false;
    },
    handleClose() {
      this.emailShow = false;
    },

    handleRemove(file, fileList) { },
    // 上传文件
    handleChange(file, fileList) {
      let formData = new FormData();
      formData.append('file', file.raw);
      if (file.size > 50 * 1024 * 1024) {
        this.$message.error('文件大小不能超过50M');
      }
      const isImage = file.raw.type.startsWith('image/');
      const isVideo = file.raw.type.startsWith('video/');
      if (isImage) {
        console.log('上传的是图片');
        // 发送图片消息
        this.sendMediaMessage(formData, 'image');
      } else if (isVideo) {
        console.log('上传的是视频');
        // 发送视频消息
        this.sendMediaMessage(formData, 'video');
      } else {
        this.$message.error('请上传图片或视频');
      }
    },
    // 附件发送消息
    sendSonMediaMessage(v) {
      console.log('子组件发送消息', v);
      const type = v.bTypeVal,
        res = v.dataMsgList;
      if (this.currentMessageType == 'email') {
        for (let i = 0; i < res.length; i++) {
          const file = res[i];
          this.emailUploadedFiles.push({
            name: file.name || file.originalName || `文件_${Date.now()}`,
            type: type,
            size: file.size || 0,
            url:
              type == 'video'
                ? file.urlHd || file.urlSd
                : file.url || file.originalUrl || file,
            id: file.id || file.idPhoto || file.idVideo || Date.now(), // 文件ID
            vip: this.chatUserInfo.userDetail.isVip,
          });
        }
      } else {
        if (this.emailFileFlag) {
          this.emailFileList.push({
            type,
            url: res.url,
            ossId: res.ossId,
          });
          return;
        }

        const timestamp = new Date().getTime();
        const requestId = generateUUID();
        const userId = this.chatUserInfo.userId;
        const platformUserId = this.chatUserInfo.platformUserId;
        let messageType = '',
          fileType = '',
          api = '',
          params = {},
          content = {};
        switch (type) {
          case 'image':
            messageType = 'photo';
            fileType = 'photo_batch';
            api = sendGalleryPhotos;
            params = {
              idsGalleryPhotos: res.map((item) => item.idPhoto),
              idRegularUser: userId,
              vip: this.chatUserInfo.userDetail.isVip,
            };
            let photos = [];
            res.forEach((item) => {
              photos.push({
                url: item.url,
              });
            });
            content = {
              photos,
            };
            break;
          case 'video':
            messageType = 'video';
            fileType = 'video';
            api = sendGalleryVideo;
            params = {
              idGalleryVideo: res[0].idVideo,
              idRegularUser: userId,
              vip: this.chatUserInfo.userDetail.isVip,
            };
            content = {
              id: res[0].idVideo,
              url: res[0].url,
            };
            break;
          case 'audio':
            messageType = 'audio';
            fileType = 'audio';
            api = sendAudio;
            params = {
              idMedia: res[0].id,
              idRegularUser: userId,
              vip: this.chatUserInfo.userDetail.isVip,
            };
            content = {
              id: res.id,
              urlMp3: res.url,
            };
            break;
        }
        console.log('api, params', params);
        this.addMessageToChatList({
          message: '',
          messageType: messageType,
          isRead: 0,
          idUserFrom: this.chatUserInfo.platformUserId,
          type: fileType,
          msgTimestamp: timestamp,
          requestId: requestId,
          content, // talktimes 返回的消息文件都在content中
        });
        api(params)
          .then((res) => {
            console.log('发送成功:', res);
            if (res.idMessage) {
              this.handleSendMsg(
                { requestId, userId, platformUserId },
                'success'
              );
            } else {
              console.error('发送失败: 没有返回idMessage');
              this.failMsg = '发送失败';
              this.sendFailDialogShow = true;
              this.handleSendMsg(
                { requestId, api, params, userId, platformUserId },
                'error'
              );
            }
          })
          .catch((err) => {
            console.error('发送失败:', err);
            if (err.error == 'Request not satisfied VIP requirements') {
              this.failMsg = '对方不满足VIP条件';
            } else {
              this.failMsg = err.error;
            }
            this.sendFailDialogShow = true;
            this.handleSendMsg(
              { requestId, api, params, userId, platformUserId },
              'error'
            );
          });

        const uploader = this.$refs.uploader;
        if (uploader && uploader.length > 0) {
          uploader[0].clearFiles();
        }
        // 如果是图片、视频是循环调用的，需要是最后一个才关闭弹窗，其他的直接关闭
        if ((type == 'video' || type == 'image') && v.isLast) {
          this.$refs.attachmentDom.closeClick();
        }
        if (type != 'video' && type != 'image') {
          this.$refs.attachmentDom.closeClick();
        }
      }
    },
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleRemove(file, fileList) {
      console.log('文件移除:', file, fileList);
    },
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },

    keydownEvent(event) {
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        this.itemClick(0);
      }
    },

    // 插入表情
    insertEmoji(emoji) {
      // 将emoji添加到输入框
      this.message += emoji;

      // 聚焦到输入框
      this.$nextTick(() => {
        if (this.$refs.editor) {
          this.$refs.editor.focus();
        }
      });
    },
    // 发送贴纸
    postStickers(data) {
      console.log('发送贴纸:', data);
      const requestId = generateUUID();
      const userId = this.chatUserInfo.userId;
      const platformUserId = this.chatUserInfo.platformUserId;
      // 添加消息到聊天列表
      this.addMessageToChatList({
        dateCreated: new Date().getTime(),
        idUserFrom: platformUserId,
        idUserTo: userId,
        type: 'sticker',
        content: data,
        requestId: requestId,
      });
      let params = {
        idSticker: data.id,
        idRegularUser: userId,
        vip: this.chatUserInfo.userDetail.isVip,
      };
      sendSticker(params)
        .then((res) => {
          console.log('贴纸发送成功:', res);
          if (res.idMessage) {
            this.handleSendMsg(
              { requestId, userId, platformUserId },
              'success'
            );
          } else {
            console.error('贴纸发送失败: 没有返回idMessage');
            this.failMsg = '发送失败';
            this.sendFailDialogShow = true;
            this.handleSendMsg(
              { requestId, api: sendSticker, params, userId, platformUserId },
              'error'
            );
          }
        })
        .catch((err) => {
          console.error('贴纸发送失败:', err);
          this.failMsg = err.error || '发送失败';
          this.sendFailDialogShow = true;
          this.handleSendMsg(
            { requestId, api: sendSticker, params, userId, platformUserId },
            'error'
          );
        });
    },
    // 发送媒体文件
    sendMediaMessage(formData, type) {
      uploadFile(formData)
        .then((res) => {
          console.log('上传文件：', res);
          const timestamp = new Date().getTime();
          const requestId = generateUUID();
          const isImage = type === 'image';

          if (isImage) {
            // TODO: 使用新版 talkytimes 接口替代
            console.warn('sendPhotoMessage 旧版接口已移除，需要使用新版接口');
          } else {
            // TODO: 使用新版 talkytimes 接口替代
            console.warn('sendVideoMessage 旧版接口已移除，需要使用新版接口');
          }
          console.log('refs', this.$refs);
          this.$refs.uploader[0].clearFiles();

          this.addMessageToChatList({
            message: '',
            messageType: isImage ? 'photo' : 'video',
            isRead: 0,
            type: isImage ? '2' : '3',
            imgUrl: res.data.url,
            msgTimestamp: timestamp,
            requestId: requestId,
            msgFiles: [
              {
                fileType: isImage ? 'photo' : 'video',
                fileUrl: res.data.url,
                params: {},
              },
            ],
          });
        })
        .catch((err) => {
          console.log(err, 'err');
          this.$refs.uploader[0].clearFiles();
          this.$message.error('上传失败');
        });
    },
    // 开始录制语音
    startRecording() {
      // 录制语音时如果未处于静音状态，则临时静音，录制完成后恢复
      if (!this.$store.state.sound.muted) {
        this.$store.dispatch('sound/setRingVal', true); // 临时静音
        this.TemporaryMute = true;
      }
      this.isRecording = true;
      recorder.start();
      this.recordTime = 0;
      if (this.recordInterval) {
        clearInterval(this.recordInterval);
        this.recordInterval = null;
      }
      this.recordInterval = setInterval(() => {
        this.recordTime++;
      }, 1000);
    },
    // 结束录制语音
    stopRecording() {
      if (this.TemporaryMute) {
        this.$store.dispatch('sound/setRingVal', false); // 恢复声音
        this.TemporaryMute = false;
      }
      this.isRecording = false;
      this.createAudioUrl = true;
      recorder.stop(); // 结束录制
      clearInterval(this.recordInterval);
      this.recordInterval = null;
      // recorder.play()  // 开始播放
      // console.log(recorder.fileSize()); // 文件大小
      let originalBlob = recorder.getBlob();
      let audioTime = this.chatUserInfo.platformUserId + Date.now();
      let file = new File([originalBlob], audioTime + '.m4a', {
        type: 'audio/m4a',
      });

      let formData = new FormData();
      formData.append('file', file);
      uploadFile(formData)
        .then((res) => {
          if (res.code == 200) {
            this.ossId = res.data.ossId;
            this.audioUrl = res.data.url;
            this.createAudioUrl = false;
          }
        })
        .catch((err) => {
          this.createAudioUrl = false;
        });
    },
    handleSelectChange(value) {
      console.log('选中的值:', value);

      if (value === '1') {
        // 切换到历史模式：重置历史记录相关状态并重新加载
        this.loadingImgShow = true;
        this.isHistoryLoading = false;
        this.isHistoryMore = true;
        this.historyParams = {
          cursor: '',
          limit: 15,
          offset: 0,
        };
        this.historyList = [];

        // 重新加载历史记录
        this.getHistoryList('new')
          .then(() => {
            this.$nextTick(() => {
              // 检查首次加载是否需要更多数据
              this.checkIfNeedMoreData();

              // 重新设置观察者
              const loadingImg = this.$refs.rightPanelDom.$refs.loadingImg;
              if (loadingImg && this.loadingImgShow) {
                // 如果已经有观察者，先断开
                if (this.historyObserver) {
                  this.historyObserver.disconnect();
                  this.historyObserver = null;
                }
                this.historyObserver = this.createObserver(
                  loadingImg,
                  'history'
                );
              }
            });
          })
          .finally(() => {
            // 重置组件的加载状态
            if (this.$refs.rightPanelDom) {
              this.$refs.rightPanelDom.resetLoadingState();
            }
          });
      } else {
        // 切换到所有资料模式：重新生成数据
        console.log(this.$refs.rightPanelDom.$refs.allMyUsersDom);
        this.$refs.rightPanelDom.$refs.allMyUsersDom.getuserlist('new');
      }
    },
    // 发送语音
    sendRecording() {
      if (this.ossId) {
        const timestamp = new Date().getTime();
        const requestId = generateUUID();

        // TODO: 使用新版 talkytimes 接口替代
        console.warn('sendAudioMessage 旧版接口已移除，需要使用新版接口');

        this.RecordingShow = false;
        this.addMessageToChatList({
          type: '1',
          message: 'Voice message',
          messageType: 'audio',
          msgTimestamp: timestamp,
          requestId: requestId,
          msgFiles: [
            {
              fileUrl: this.audioUrl,
            },
          ],
        });
      }
    },
    // 录音播放
    pausePlay() { },
    async getEmailCoverList() {
      let res = await getEmailCoverList({
        platformType: this.chatUserInfo.platformType,
      });
      this.coverList = res;
    },
    clickCover(item, index) {
      this.coverIndex = index;
      let emailHeader = document.querySelector('.emailHeader');
      emailHeader.style.backgroundImage = `url(${item.coverUrl})`;
    },

    retryMessage(rowData) {
      console.log('消息重试', rowData);
    },
    sendMessageFail(failedList) {
      console.log('发送失败', failedList);
      // 设置弹窗显示状态
      this.$message.warning('发送失败，请稍后重试');
    },
    // 处理发送失败弹窗的按钮点击
    handleSendFailAction(action) {
      switch (action) {
        case 'delete':
          // 删除该用户
          delChat({
            chatId: this.generateChatId(),
            platformUserId: this.chatUserInfo.platformUserId,
            recId: this.generateChatId(),
          }).then((res) => {
            this.getHistoryList('new');
            console.log('执行了吗2');
            this.chatUserInfo = '';
            this.sendFailDialogShow = false; // 关闭发送失败弹窗
            this.failMsg = ''; // 清空失败消息内容
          });
          break;
        case 'check':
          // 前往dating平台查看
          window.open('https://www.dating.com', '_blank');
          break;
        case 'later':
          // 稍后处理，不执行任何操作
          this.sendFailDialogShow = false;
          this.failMsg = '';
          break;
      }
    },
    // 生成聊天ID（用于WebSocket消息发送）
    generateChatId() {
      if (!this.chatUserInfo.platformUserId || !this.chatUserInfo.userId) {
        return '';
      }
      return `tt-${this.chatUserInfo.platformUserId}-${this.chatUserInfo.userId}`;
    },

    // 拖拽相关方法
    startResize(event, type) {
      this.isDragging = true;
      this.dragType = type;
      this.startX =
        event.type === 'mousedown' ? event.clientX : event.touches[0].clientX;
      this.startLeftWidth = this.leftWidth;
      this.startCenterWidth = this.centerWidth;
      this.startRightWidth = this.rightWidth;

      // 添加鼠标移动和释放事件监听器
      document.addEventListener('mousemove', this.handleResize);
      document.addEventListener('mouseup', this.stopResize);
      document.addEventListener('touchmove', this.handleResize);
      document.addEventListener('touchend', this.stopResize);

      // 防止文本选择
      document.body.style.userSelect = 'none';
      document.body.style.cursor = 'col-resize';
      event.preventDefault();
    },
    handleResize(event) {
      if (!this.isDragging) return;

      const currentX =
        event.type === 'mousemove' ? event.clientX : event.touches[0].clientX;
      const deltaX = currentX - this.startX;
      const containerWidth = document.querySelector('.message').offsetWidth;
      const deltaPercent = (deltaX / containerWidth) * 100;

      if (this.dragType === 'left') {
        // 拖拽左侧分隔条
        const newLeftWidth = Math.max(
          15,
          Math.min(40, this.startLeftWidth + deltaPercent)
        );
        const newCenterWidth =
          this.startCenterWidth - (newLeftWidth - this.startLeftWidth);

        // 确保中间区域不会太小
        if (newCenterWidth >= 30) {
          this.leftWidth = newLeftWidth;
          this.centerWidth = newCenterWidth;
        }
      } else if (this.dragType === 'right') {
        // 拖拽右侧分隔条
        const newRightWidth = Math.max(
          15,
          Math.min(40, this.startRightWidth - deltaPercent)
        );
        const newCenterWidth =
          this.startCenterWidth - (newRightWidth - this.startRightWidth);

        // 确保中间区域不会太小
        if (newCenterWidth >= 30) {
          this.rightWidth = newRightWidth;
          this.centerWidth = newCenterWidth;
        }
      }
    },
    stopResize() {
      this.isDragging = false;
      this.dragType = '';

      // 移除事件监听器
      document.removeEventListener('mousemove', this.handleResize);
      document.removeEventListener('mouseup', this.stopResize);
      document.removeEventListener('touchmove', this.handleResize);
      document.removeEventListener('touchend', this.stopResize);

      // 恢复默认样式
      document.body.style.userSelect = '';
      document.body.style.cursor = '';
    },

    // 处理来自搜索页面的跳转请求
    handleSearchPageRedirect() {
      const { action, userData } = this.$route.query;

      if (action === 'startChat' && userData) {
        const user = JSON.parse(userData);
        console.log('来自搜索页面的用户数据:', user);

        // 调用clickHistory方法开始聊天
        this.clickHistory(user, 'chat');

        // 清除URL中的查询参数，避免重复处理
        this.$router.replace({
          path: '/talkytimes/message',
          query: {},
        });
      } else if (action === 'startEmail' && userData) {
        const user = JSON.parse(userData);
        console.log('来自搜索页面的用户数据:', user);

        // 调用clickHistory方法开始聊天
        this.clickHistory(user, 'email');

        // 清除URL中的查询参数，避免重复处理
        this.$router.replace({
          path: '/talkytimes/message',
          query: {},
        });
      }
    },

    // 邮件附件相关方法
    // 格式化文件大小
    formatFileSize(bytes) {
      if (bytes === 0) return '0 B';
      const k = 1024;
      const sizes = ['B', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },

    // 移除单个邮件附件
    removeEmailFile(index) {
      this.emailUploadedFiles.splice(index, 1);
    },

    // 清空所有邮件附件
    clearEmailFiles() {
      this.emailUploadedFiles = [];
    },

    // 保存页面状态
    savePageState() {
      // 检查是否正在退出登录，如果是则不保存状态
      const token = localStorage.getItem('Admin-Token');
      if (!token) {
        console.log('检测到退出登录，跳过保存页面状态');
        return;
      }

      const state = {
        scrollPosition: this.$refs.messageList
          ? this.$refs.messageList.scrollTop
          : 0,
        newMessageScrollPosition: this.$refs.newMessageContainer
          ? this.$refs.newMessageContainer.scrollTop
          : 0,
        activeTab: this.activeTab,
        currentMessageType: this.currentMessageType,
        message: this.message,
        chatUserInfo: this.chatUserInfo,
        leftWidth: this.leftWidth,
        centerWidth: this.centerWidth,
        timestamp: Date.now(),
      };
      sessionStorage.setItem('messagePageState', JSON.stringify(state));
    },

    // 恢复页面状态
    restorePageState() {
      // 检查是否已登录，如果没有登录则不恢复缓存状态
      const token = localStorage.getItem('Admin-Token');
      if (!token) {
        console.log('未登录状态，跳过恢复消息页面状态');
        return;
      }

      const savedState = sessionStorage.getItem('messagePageState');
      if (savedState) {
        try {
          const state = JSON.parse(savedState);
          // 检查状态是否过期（超过30分钟）
          if (Date.now() - state.timestamp > 30 * 60 * 1000) {
            sessionStorage.removeItem('messagePageState');
            return;
          }

          // 恢复状态
          this.activeTab = state.activeTab || 'new';
          this.currentMessageType = state.currentMessageType || 'chat';
          this.message = state.message || '';
          this.leftWidth = state.leftWidth || 30;
          this.centerWidth = state.centerWidth || 70;

          // 恢复滚动位置
          this.$nextTick(() => {
            if (state.scrollPosition && this.$refs.messageList) {
              this.$refs.messageList.scrollTop = state.scrollPosition;
            }
            if (
              state.newMessageScrollPosition &&
              this.$refs.newMessageContainer
            ) {
              this.$refs.newMessageContainer.scrollTop =
                state.newMessageScrollPosition;
            }
          });
        } catch (error) {
          console.error('恢复页面状态失败:', error);
          sessionStorage.removeItem('messagePageState');
        }
      }
    },
    // 启动紧急提醒检查定时器
    startUrgentCheckTimer() {
      // 清理现有定时器
      if (this.urgentCheckTimer) {
        clearInterval(this.urgentCheckTimer);
      }

      // 每分钟检查一次
      this.urgentCheckTimer = setInterval(() => {
        // 强制更新计算属性
        this.$forceUpdate();
      }, 60000); // 每分钟检查一次
    },

    // 更新store中的未读数量
    updateStoreUnreadCount() {
      try {
        // 获取当前新消息列表的长度
        const newMessagePanel = this.$refs.newMessagePanel;
        if (newMessagePanel && newMessagePanel.newMessageList) {
          const currentUnreadCount = newMessagePanel.newMessageList.length;

          // 调用store action更新未读数量
          this.$store.dispatch(
            'accountList/updateUnreadCountByNewMessages',
            Array(currentUnreadCount).fill({})
          ); // 传递一个长度为currentUnreadCount的数组

          console.log('已更新store中的未读数量:', currentUnreadCount);
        }
      } catch (error) {
        console.error('更新store未读数量失败:', error);
      }
    },

    // 处理未读数量变化
    handleUnreadCountChanged(count) {
      try {
        console.log('收到未读数量变化事件:', count);

        // 调用store action更新未读数量
        this.$store.dispatch(
          'accountList/updateUnreadCountByNewMessages',
          Array(count).fill({})
        ); // 传递一个长度为count的数组

        console.log('已更新store中的未读数量:', count);
      } catch (error) {
        console.error('更新store未读数量失败:', error);
      }
    },
  },
  created() { },
  mounted() {
    // setTimeout(() => {
    //   console.log('开始播放消息提示音');
    //   setInterval(() => {
    //     this.playMessageSound(false);
    //   }, 10);
    // }, 2000);
    // 初始化弹窗状态
    this.giftPromptModalVisible = false;

    // 获取当前用户消息列表
    // 登录后检查并显示更新通知
    if (this.$root.checkUpdateNotice) {
      // 延迟一下确保页面完全加载
      this.$nextTick(() => {
        setTimeout(() => {
          this.$root.checkUpdateNotice();
        }, 500);
      });
    }
    //  登录成功后获取敏感词
    this.$store.dispatch('fetchSensitiveWords');

    // 设置Vue实例到工具模块中，用于事件触发
    setVueInstance(this);

    this.initSocket();
    // 初始化历史对话列表
    this.getHistoryList('new').then(() => {
      this.$nextTick(() => {
        // 检查首次加载是否需要更多数据
        this.checkIfNeedMoreData();

        // 设置观察者
        const loadingImg = this.$refs.rightPanelDom.$refs.loadingImg;
        if (loadingImg) {
          this.historyObserver = this.createObserver(loadingImg, 'history');
        }

        // 检查是否有来自搜索页面的跳转请求
        this.handleSearchPageRedirect();

        // 恢复页面状态
        this.restorePageState();
      });
    });

    // 启动紧急提醒检查定时器
    this.startUrgentCheckTimer();

    // 启动历史记录自动刷新定时器（每10秒静默刷新一次）
    console.log('启动历史记录自动刷新定时器');
    this.historyRefreshTimer = setInterval(() => {
      console.log('定时器触发，准备刷新历史记录');
      this.silentRefreshHistoryList();
    }, 60000); // 10秒刷新一次
  },
  activated() {
    // 组件被激活时恢复状态
    this.restorePageState();
    this.$refs.newMessagePanel?.fetchLikeMessageTotal();
  },
  deactivated() {
    // 组件被停用时保存状态
    this.savePageState();
  },
  beforeDestroy() {
    // 从全局WebSocket管理器注销消息处理器
    if (this.messageListenerCallback) {
      globalWebSocketManager.unregisterMessageHandler('message-page');
      this.messageListenerCallback = null;
    }

    // 清理连接引用
    this.sw = null;
    // 移除滚动事件监听器
    const messageList = this.$refs.messageList;
    if (messageList) {
      messageList.removeEventListener('scroll', this.handleScroll);
    }

    // 消息轮询相关清理已移除
    // 清除在线查询定时器
    if (this.onlineQueryTimer) {
      clearTimeout(this.onlineQueryTimer);
      this.onlineQueryTimer = null;
    }

    // 清理观察者
    if (this.historyObserver) {
      this.historyObserver.disconnect();
      this.historyObserver = null;
    }

    // 清理拖拽事件监听器
    document.removeEventListener('mousemove', this.handleResize);
    document.removeEventListener('mouseup', this.stopResize);
    document.removeEventListener('touchmove', this.handleResize);
    document.removeEventListener('touchend', this.stopResize);

    // 注销SSE消息处理器
    sseManager.unregisterMessageHandler('messagePage');

    // 清理紧急提醒检查定时器
    if (this.urgentCheckTimer) {
      clearInterval(this.urgentCheckTimer);
      this.urgentCheckTimer = null;
    }

    // 清理历史记录自动刷新定时器
    if (this.historyRefreshTimer) {
      clearInterval(this.historyRefreshTimer);
      this.historyRefreshTimer = null;
    }
  },
  // updated() {
  //     ts.scrollToBottom();
  // }
};
</script>
<style lang="scss" scoped>
.loadingImg {
  width: 30px;
  height: 30px;
  margin: 0 auto;
}

.RecordingShow {
  .recordingContent {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .img {
      width: 30px;
      height: 30px;
      margin-bottom: 6px;
    }

    .text {
      margin-left: 10px;
      font-size: 14px;
      color: #333333;
      text-align: center;
    }
  }

  .buttons {
    display: flex;
    justify-content: space-around;
    margin-top: 24px;

    .item {
      box-sizing: border-box;
      padding: 6px 16px;
      background: #ffffff;
      border-radius: 16px;
      line-height: 32px;
      text-align: center;
      font-size: 14px;
      color: #333333;
      cursor: pointer;
    }

    .item:hover {
      background: #f5f5f5;
    }
  }
}

.dropdownMenu {
  width: 120px;

  .item {
    display: flex;
    align-items: center;
    justify-content: center;

    .itemImg {
      width: 20px;
      height: 20px;
      margin-right: 12px;
    }

    .itemName {
      font-weight: 400;
      font-size: 14px;
      color: #333333;
    }
  }
}

::v-deep .el-dialog {
  border-radius: 30px;
}

::v-deep .el-dialog__header {
  padding: 0;
  z-index: 1 !important;
}

::v-deep .el-dialog__body {
  padding: 24px;
}

.emailDialog {
  ::v-deep .el-dialog__body {
    padding: 0;
    border-radius: 18px;
    padding-bottom: 24px;
  }
}

.message {
  width: 100%;
  margin-top: 8px;
  flex: 1;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  position: relative;
  // padding-bottom: 28px;

  .left {
    // width: 22%;
    min-width: 250px;
    background-color: #fff;
    border-radius: 18px;
    box-sizing: border-box;
    padding: 20px;
    height: calc(100vh - 80px);

    .leftTopBox {
      height: 100%;
    }

    .leftBottomBox {
      height: 50%;
    }

    .left_content {
      box-sizing: border-box;
      overflow-y: auto;
      overflow-x: hidden;
      height: calc(100% - 50px);

      // 隐藏x轴滚动条
      &::-webkit-scrollbar-x {
        display: none;
      }
    }
  }

  .center {
    // width: 49%;
    background-color: #fff;
    border-radius: 18px;
    box-sizing: border-box;
    padding: 16px;
    display: flex;
    flex-direction: column;
    height: calc(100vh - 80px);
    margin: 0 10px;

    .center_title {
      width: 100%;
      // height: 76px;
      border-radius: 18px;
      box-sizing: border-box;
      padding: 8px 12px;
      background-color: #f7f9fa;
      display: flex;
      align-items: center;
      margin-bottom: 18px;
      // flex-shrink: 0;

      .title {
        width: 100%;
        display: flex;
        align-items: center;

        .cards {
          width: 80%;
          display: flex;
          flex-shrink: 0;
          overflow-x: auto;
        }

        .title_icon {
          display: flex;
          align-items: center;
          margin-left: auto;

          .imgs {
            width: 40px;
            height: 40px;
            margin-right: 12px;
            cursor: pointer;
          }

          .imgs2 {
            width: 38px;
            height: 26px;
            cursor: pointer;
          }
        }
      }
    }

    .infoList {
      width: 100%;
      flex: 1;
      overflow-y: auto; // 显示滚动条
      // margin-bottom: 40px;
      border-bottom: 1px solid #ddd;
    }

    .input {
      display: flex;
      align-items: center;
      width: 100%;
      flex-shrink: 0;
      position: relative;
      padding-top: 40px;

      .items_iconList {
        width: 100%;
        display: flex;
        align-items: center;
        position: absolute;
        top: 5px;

        .icon {
          width: 22px;
          height: 22px;
          margin-right: 20px;
        }

        .item {
          margin-right: 20px;
        }
      }

      .input_info {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        flex: 1;
        height: 120px;
        /* 固定高度为120px */
        max-height: 120px;
        /* 最大高度限制 */
        background-color: #f7f9fa;
        border-radius: 20px;
        position: relative;
        /* 为绝对定位的子元素提供参考 */

        .highlight-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 60px;
          height: 100%;
          box-sizing: border-box;
          background-color: transparent;
          border-radius: 20px 4px 20px 20px;
          padding: 14px 20px;
          font-family: inherit;
          font-size: 14px;
          line-height: 1.4;
          pointer-events: none;
          /* 关键：让div的换行方式与textarea保持一致 */
          white-space: pre-wrap;
          word-wrap: break-word;
          word-break: break-word;
          overflow-wrap: break-word;
          /* 字间距和字体渲染完全对齐 */
          letter-spacing: normal;
          word-spacing: normal;
          font-variant: normal;
          font-stretch: normal;
          font-feature-settings: normal;
          font-kerning: auto;
          text-indent: 0;
          text-transform: none;
          text-decoration: none;
          text-shadow: none;
          tab-size: 4;
          -moz-tab-size: 4;
          -webkit-tab-size: 4;
          /* 边框相关 */
          border: none;
          border-radius: 20px 4px 20px 20px;
          outline: none;
          /* 文本渲染优化 */
          text-rendering: auto;
          -webkit-font-smoothing: auto;
          -moz-osx-font-smoothing: auto;
          -webkit-text-stroke: 0;
          /* 滚动设置 */
          overflow-y: auto;
          overflow-x: hidden;
          z-index: 2;
          color: transparent;
          /* 隐藏滚动条但保持滚动功能 */
          scrollbar-width: none;
          -ms-overflow-style: none;

          &::-webkit-scrollbar {
            display: none;
          }
        }

        .messageInput {
          height: 100%;
          width: calc(100% - 60px);
          background-color: transparent;
          border-radius: 20px;
          box-sizing: border-box;
          background: transparent;
          border: none;
          border-radius: 20px 4px 20px 20px;
          padding: 14px 20px;
          resize: none;
          /* 关键：让textarea的换行方式与div保持一致 */
          white-space: pre-wrap;
          word-wrap: break-word;
          word-break: break-word;
          overflow-wrap: break-word;
          /* 字间距和字体渲染完全对齐 */
          letter-spacing: normal;
          word-spacing: normal;
          font-variant: normal;
          font-stretch: normal;
          font-feature-settings: normal;
          font-kerning: auto;
          text-indent: 0;
          text-transform: none;
          text-decoration: none;
          text-shadow: none;
          tab-size: 4;
          -moz-tab-size: 4;
          -webkit-tab-size: 4;
          /* 文本渲染优化 */
          text-rendering: auto;
          -webkit-font-smoothing: auto;
          -moz-osx-font-smoothing: auto;
          -webkit-text-stroke: 0;
          /* 滚动设置 */
          overflow-y: auto;
          overflow-x: hidden;
          /* 隐藏滚动条但保持滚动功能 */
          scrollbar-width: none;
          /* Firefox */
          -ms-overflow-style: none;

          /* IE and Edge */
          &::-webkit-scrollbar {
            display: none;
            /* Chrome, Safari, Opera */
          }

          font-family: inherit;
          font-size: 14px;
          line-height: 1.4;
          color: #333;
          outline: none;
          /* 隐藏滚动条但保持滚动功能 */
          scrollbar-width: none;
          /* Firefox */
          -ms-overflow-style: none;

          /* IE and Edge */
          &::-webkit-scrollbar {
            display: none;
            /* Chrome, Safari, Opera */
          }

          :deep(.el-input__count) {
            color: #999999;
            background: none;
            left: 18px;
          }
        }

        .send_icon {
          padding: 16px;
          cursor: pointer;
        }
      }

      :deep(.messageInput:focus) {
        outline: none;
      }

      .tools {
        position: absolute;
        display: flex;

        // flex-direction: column;
        .item:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  .right {
    // width: 25%;
    min-width: 250px;
    height: calc(100vh - 80px);
    background-color: #fff;
    border-radius: 18px;
    box-sizing: border-box;
    padding: 16px;
    display: flex;
    flex-direction: column;

    .right-btns {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .tab {
        padding: 14px 18px;
        background-color: rgb(222, 240, 255);
        border-radius: 8px;
        text-align: center;
        color: #2499ff;
        margin-bottom: 18px;
        cursor: pointer;
      }
    }

    .history {
      width: 200px;
      height: 48px;
      box-sizing: border-box;
      padding: 14px 18px;
      background: #f7f9fa;
      border-radius: 8px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 18px;

      :deep(.el-input__inner) {
        border: none;
        background-color: #f7f9fa;
        font-weight: 400;
        font-size: 18px;
        color: #333333;
      }
    }

    .message_list {
      flex: 1;
      overflow-y: auto; // 显示滚动条
      overflow-x: hidden;
    }
  }

  .iconList {
    position: absolute;
    left: 10px;
    top: -30px;
    z-index: 999;
    display: flex;

    .icon {
      width: 26px;
      height: 26px;
      margin-bottom: 12px;
      cursor: pointer;
      margin-left: 16px;
    }
  }
}

.emojiList {
  // width: 300px;
  display: flex;
  height: 120px;
  flex-wrap: wrap;
  overflow: auto;
  align-content: flex-start;

  .emoji {
    width: 40px;
    height: 40px;
    // padding: 6px 6px;
  }

  .tsEmoji {
    width: 40px;
    /* 单个帧的宽度 */
    height: 40px;
    /* 单个帧的高度 */
    /* 精灵图的路径 */
    background-repeat: no-repeat;
    background-size: 1280px 40px;
  }

  @keyframes spriteAnimation {
    0% {
      background-position: 0 0;
    }

    100% {
      background-position: -1280px 0;
    }

    /* 回到第一帧 */
  }

  .animated-sprite {
    animation: spriteAnimation 1s steps(32) infinite;
    /* 2秒周期，5步，无限循环 */
  }
}

.emojiTabList {
  width: 420px;
  box-sizing: border-box;
  display: flex;
  padding: 0 20px;
  margin-bottom: 10px;

  .tabItem {
    // width: 40px;
    padding: 0 10px;
    text-align: center;
    cursor: pointer;
  }
}

:deep(.el-dropdown) {
  display: block !important;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(128, 128, 128, 0.5);
  /* 灰色半透明蒙层 */
  z-index: 998;
  pointer-events: auto;
  /* 如果你想阻止点击，设为 auto 或 none */
}

// :deep(.el-upload-list) {
//     display: none;
// }

.emailBox {
  .emailTopBox {
    padding: 24px;
  }

  .emailHeader {
    height: 218px;
    width: 100%;
    border-radius: 8px;
    background-image: url('@/assets/emailBg.png');
    background-size: 100% 100%;
  }

  .emailTop {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .headShot {
    width: 78px;
    height: 78px;
    background: red;
    border-radius: 50%;
    margin-bottom: 10px;
    margin-top: 40px;

    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }

  .headName {
    font-weight: 500;
    font-size: 20px;
    color: #333333;
    // line-height: 28px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin-bottom: 10px;
  }

  .headNew {
    width: 38px;
    height: 20px;
    background: #ff2424;
    border-radius: 10px 10px 10px 10px;
    border: 1px solid #ff2424;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    line-height: 20px;
    font-style: normal;
    text-transform: none;
    text-align: center;
  }

  .emailTab {
    display: flex;
    align-items: center;

    .row {
      display: flex;
      padding: 12px 40px;

      img {
        width: 22px;
        height: 18px;
        margin-right: 8px;
      }
    }
  }

  .actionRow {
    background: #eeeeee;
    border-radius: 8px 8px 8px 8px;
  }

  .tips {
    font-weight: 400;
    font-size: 20px;
    color: #333333;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin: 18px 0;
  }

  .warnigMessage {
    display: flex;
    align-items: center;
    background: #f7f9fa;
    border-radius: 4px 4px 4px 4px;
    padding: 12px;

    img {
      width: 16px;
      height: 16px;
      margin-right: 4px;
    }
  }

  .protocolRow {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;

    img {
      width: 18px;
      height: 18px;
      margin-right: 6px;
    }
  }

  .sendEmailBtn {
    // padding: 12px 40px;
    font-weight: 500;
    font-size: 18px;
    color: #ffffff;
    text-align: left;
    font-style: normal;
    text-transform: none;
    background: #ff2424;
    border-radius: 8px 8px 8px 8px;
    display: flex;
    width: 182px;
    height: 44px;
    align-items: center;
    justify-content: center;
    margin: auto;
    margin-top: 24px;

    img {
      width: 22px;
      height: 18px;
      margin-right: 8px;
    }
  }

  .tab-bar {
    display: flex;
    align-items: center;
    position: relative;
  }

  .arrow {
    width: 30px;
    height: 30px;
    cursor: pointer;
    z-index: 999;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .arrowLeft {
    position: absolute;
    left: 12px;
    bottom: 26px;
  }

  .arrowRight {
    position: absolute;
    right: 12px;
    bottom: 26px;
  }

  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(128, 128, 128, 0.5);
    /* 半透明黑色蒙层 */
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    z-index: 1;
    font-size: 20px;
    font-weight: bold;
  }

  .tab-container {
    display: flex;
    width: 100%;
    overflow-x: hidden;
  }

  .tab {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    // min-width: 25%;
    width: 100%;
    text-align: center;
    background-color: #3a7fa9;
  }

  .text {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .img {
    flex-shrink: 0;
    width: 180px;
    height: 80px;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
      // border-radius: 8px;
    }
  }

  .selectIcon {
    position: absolute;
    width: 26px;
    height: 18px;
    z-index: 9999;
  }
}

// 快捷信息
.msgTabListBox {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding: 0 20px;
  box-sizing: border-box;

  .leftBox {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 200px;

    .tabItem {
      padding: 0 10px;
      text-align: center;
      cursor: pointer;
    }
  }
}

.msgListBox {
  // display: flex;
  // flex-direction: column;
  height: 200px;
  // flex-wrap: wrap;
  overflow-y: scroll;
  overflow-x: hidden;
  // align-content: flex-start;
  width: 100%;

  :deep(.el-dropdown-menu__item) {
    width: 380px !important;
  }

  :deep(.el-dropdown-menu__item:not(.is-disabled):hover) {
    background-color: transparent !important;
    color: inherit !important;
  }

  /* 如果需要同时取消聚焦效果 */
  :deep(.el-dropdown-menu__item:focus) {
    background-color: transparent !important;
    color: inherit !important;
    box-sizing: border-box;
  }

  .msgLiBox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 380px;

    .leftBox {
      width: 360px;
      white-space: nowrap;
      /* 强制不换行 */
      overflow: hidden;
      /* 隐藏溢出内容 */
      text-overflow: ellipsis;
      /* 显示省略号 */
    }

    .rightBox {
      width: 15px;
      height: 15px;
    }
  }
}

// 创建组别弹窗样式
.addAndPutBox {
  padding: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .title {
    font-weight: 600;
    font-size: 24px;
    text-align: center;
  }

  .firBox,
  .secBox {
    width: 60%;
    margin-top: 40px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border: 1px solid #e4f3ff;

    .mtitle {
      width: 100px;
      height: 40px;
      background-color: #2499ff;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
    }

    .rcontent {
      flex: 1;

      ::v-deep .el-select {
        width: 100%;

        .el-input__inner {
          border: none;
        }
      }

      ::v-deep .el-input__inner {
        border: none;
      }
    }
  }

  .secBox {
    margin-top: 20px;
  }
}

// 对话框居中
.middleDialog::v-deep.el-dialog__wrapper {
  top: 5vh;
  // height: 90vh;

  .el-dialog {
    // height: 100%;

    .el-dialog__body {
      height: calc(90vh - 5px);
      box-sizing: border-box;
    }
  }
}

// 发送失败弹窗样式
.send-fail-dialog-wrapper {
  ::v-deep .el-dialog {
    border-radius: 16px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);

    .el-dialog__body {
      padding: 0;
    }
  }
}

.send-fail-dialog {
  padding: 40px 30px 30px;
  text-align: center;

  .dialog-header {
    margin-bottom: 30px;

    .warning-icon-bg {
      width: 80px;
      height: 80px;
      margin: 0 auto 20px;
      background: linear-gradient(135deg, #fff3e0 0%, #ffecb3 100%);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 8px 24px rgba(255, 152, 0, 0.2);

      i {
        font-size: 36px;
        color: #ff9800;
      }
    }

    .dialog-title {
      font-size: 24px;
      font-weight: 600;
      color: #2c3e50;
      margin: 0;
      letter-spacing: 0.5px;
    }
  }

  .dialog-content {
    margin-bottom: 40px;
    padding: 0 20px;

    .main-text {
      font-size: 16px;
      color: #34495e;
      font-weight: 500;
      margin: 0 0 12px 0;
      line-height: 1.6;
    }

    .sub-text {
      font-size: 14px;
      color: #7f8c8d;
      line-height: 1.7;
      margin: 0;
    }
  }

  .dialog-buttons {
    display: flex;
    flex-direction: row;
    gap: 16px;
    justify-content: center;
    align-items: center;

    .dialog-btn {
      flex: 1;

      i {
        margin-right: 6px;
      }
    }

    @media (max-width: 480px) {
      flex-direction: column;
      gap: 12px;

      .dialog-btn {
        flex: none;
        max-width: none;
      }
    }
  }
}

// 限制状态栏样式
.limit-status-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 12px;
  background: #eff6fb;
  border-radius: 6px;
  max-width: 90vw;
  flex-wrap: wrap;
  justify-content: center;
  z-index: 10;

  .limit-item {
    display: flex;
    align-items: center;
    gap: 4px;
    border-radius: 3px;
    transition: background-color 0.2s ease;

    &:hover {
      background: #f5f9ff;
    }

    .limit-icon {
      width: 14px;
      height: 14px;
      opacity: 1;
      color: #1f6cbf;
      transition: all 0.2s ease;

      &.disabled {
        opacity: 0.4;
        color: #999;
      }
    }

    .limit-text {
      font-size: 12px;
      font-weight: 500;
      color: #1f6cbf;
      white-space: nowrap;
      transition: color 0.2s ease;

      &.disabled {
        color: #999;
      }
    }
  }
}

// 拖拽条样式
.resize-handle {
  width: 10px;
  height: calc(100vh - 80px);
  background: transparent;
  cursor: col-resize;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
  flex-shrink: 0;

  &:hover {
    background: linear-gradient(to bottom,
        #e8f4fd 0%,
        #b9e0f7 50%,
        #e8f4fd 100%);
    box-shadow: 0 0 8px rgba(36, 153, 255, 0.3);
  }

  &:active {
    background: linear-gradient(to bottom,
        #d4edfd 0%,
        #a8d8f5 50%,
        #d4edfd 100%);
  }

  &::before {
    content: '';
    position: absolute;
    width: 2px;
    height: 60px;
    background: #ddd;
    border-radius: 1px;
    transition: all 0.2s ease;
  }

  &:hover::before {
    background: #2499ff;
    height: 80px;
    box-shadow: 0 0 4px rgba(36, 153, 255, 0.4);
  }

  &:active::before {
    background: #1976d2;
    transform: scale(1.1);
  }
}

.left-handle {
  margin-left: 2px;
  margin-right: -8px;
}

.right-handle {
  margin-left: -8px;
  margin-right: 1px;
}

// 占位聊天框样式
.empty-chat {
  background-color: #fff;
  border-radius: 18px;
  box-sizing: border-box;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 80px);
  margin: 0 10px;

  .empty-chat-content {
    text-align: center;
    color: #909399;

    .empty-icon {
      display: flex;
      justify-content: center;
      margin-bottom: 24px;

      img {
        width: 80px;
        height: 80px;
      }
    }

    .empty-title {
      font-size: 20px;
      font-weight: 500;
      color: #606266;
      margin-bottom: 12px;
    }

    .empty-subtitle {
      font-size: 14px;
      color: #909399;
      line-height: 1.6;
    }
  }
}

.sticker-tab-scroll {
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  padding-bottom: 4px;
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* IE and Edge */
}

.sticker-tab-scroll::-webkit-scrollbar {
  display: none;
  /* Chrome, Safari, Opera */
}

.sticker-tab-scroll .tabItem {
  min-width: 48px;
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.sticker-el-tabs {
  .el-tabs__header {
    margin: 0;
    border: none;
    background: none;
  }

  .el-tabs__nav-wrap {
    overflow-x: auto !important;
    overflow-y: hidden;
    scrollbar-width: none;
    -ms-overflow-style: none;
    border: none;
    background: none;
    position: relative;
    display: flex;
    align-items: center;
    height: 56px;
  }

  .el-tabs__nav {
    border: none !important;
    background: none !important;
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 0 8px;
  }

  .el-tabs__item {
    min-width: 48px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none !important;
    background: none !important;
    margin: 0;
    height: 48px;
  }

  .el-tabs__active-bar {
    display: none !important;
  }

  .el-tabs__item.is-active {
    color: inherit !important;
    border-bottom: none !important;
  }

  .el-tabs__nav-next,
  .el-tabs__nav-prev {
    display: flex !important;
    align-items: center;
    justify-content: center;
    height: 100%;
    top: 0 !important;
    bottom: 0 !important;
    transform: none !important;
  }
}

.sticker-content-scroll {
  height: 120px;
  overflow-y: auto;
  overflow-x: hidden;
  align-content: flex-start;
  display: flex;
  flex-wrap: wrap;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.sticker-content-scroll::-webkit-scrollbar {
  display: none;
}

.item.disabled {
  opacity: 0.5;
  pointer-events: none;
}

// 邮件附件展示组件样式
.email-files-container {
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
  box-sizing: border-box;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  transform: translateY(-100%);
  width: 100%;

  .email-files-scroll {
    overflow-x: auto;
    overflow-y: hidden;
    scrollbar-width: thin;
    scrollbar-color: #adb5bd #f8f9fa;
    position: relative;
    width: calc(100% - 56px);

    &::-webkit-scrollbar {
      height: 6px;
    }

    &::-webkit-scrollbar-track {
      background: #f8f9fa;
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
      background: #adb5bd;
      border-radius: 3px;

      &:hover {
        background: #6c757d;
      }
    }
  }

  .email-files-list {
    display: flex;
    gap: 6px;
    padding: 4px 0;
    min-width: max-content;
  }

  .file-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: transparent;
    border: none;
    border-radius: 0;
    transition: all 0.2s ease;
    position: relative;

    &:hover {
      background: rgba(0, 123, 255, 0.05);
      border-radius: 6px;
    }

    .file-thumbnail {
      width: 70px;
      height: 70px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 6px;
      overflow: hidden;
      background: #fff;
      border: 1px solid #e9ecef;
    }

    .file-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 4px;
    }

    .file-video {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 4px;
    }

    .file-icon {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #007bff;
      color: white;
      border-radius: 4px;

      i {
        font-size: 20px;
      }

      &.el-icon-headset {
        background: #fff3cd;
        color: #ffc107;
      }

      &.el-icon-document {
        background: #d1ecf1;
        color: #17a2b8;
      }
    }

    .file-actions {
      position: absolute;
      top: 2px;
      right: 2px;
      z-index: 1;

      .remove-btn {
        color: #dc3545;
        padding: 2px;
        font-size: 10px;
        background: rgba(255, 255, 255, 0.9);
        border-radius: 50%;

        &:hover {
          background-color: #f8d7da;
        }
      }
    }
  }

  .clear-btn {
    position: absolute;
    top: 50%;
    right: 8px;
    transform: translateY(-50%);
    color: #dc3545;
    font-size: 14px;
    width: 40px;
    height: 40px;
    padding: 0;
    background: rgba(255, 255, 255, 0.95);
    border: 1px solid #e9ecef;
    border-radius: 50%;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: all 0.2s ease;

    &:hover {
      background-color: #f8d7da;
      border-color: #dc3545;
      box-shadow: 0 2px 8px rgba(220, 53, 69, 0.2);
      transform: translateY(-50%) scale(1.05);
    }

    &:active {
      transform: translateY(-50%) scale(0.95);
    }

    i {
      margin: 0;
      font-size: 16px;
    }
  }
}

// 加载状态
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: #909399;
}

.loading-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #e4e7ed;
  border-top: 3px solid #409eff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 12px;

  &.small {
    width: 20px;
    height: 20px;
    border-width: 2px;
    margin-bottom: 8px;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.loading-text {
  font-size: 14px;
  color: #909399;
}

// 空聊天状态
.empty-chat-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
  color: #909399;
}

.empty-email-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
  color: #909399;
}

.empty-email-message {
  text-align: center;

  i {
    font-size: 48px;
    color: #c0c4cc;
    margin-bottom: 16px;
    display: block;
  }

  p {
    margin: 8px 0;
    font-size: 14px;

    &:first-of-type {
      font-weight: 500;
      color: #606266;
    }

    &:last-of-type {
      font-size: 12px;
      color: #909399;
    }
  }
}

.empty-chat-content {
  text-align: center;
}

.empty-chat-icon {
  margin-bottom: 16px;

  img {
    // width: 64px;
    height: 64px;
    opacity: 0.6;
  }
}

.empty-chat-title {
  font-size: 16px;
  font-weight: 500;
  color: #606266;
  margin-bottom: 8px;
}

.empty-chat-subtitle {
  font-size: 14px;
  color: #909399;
}

/* 消息类型切换按钮样式 */
.message-type-switch {
  margin: 0 15px;
  display: flex;
  align-items: center;
  gap: 10px;

  .message-status-indicator {
    .el-tag {
      display: flex;
      align-items: center;
      gap: 4px;
      font-size: 12px;
      padding: 4px 8px;

      i {
        font-size: 12px;
      }
    }
  }

  .el-button-group {
    display: flex;

    .switch-btn {
      padding: 8px 16px;
      font-size: 13px;
      border-radius: 4px;
      transition: all 0.3s ease;
      height: 32px;
      min-width: 80px;
      display: flex;
      align-items: center;
      justify-content: center;

      i {
        margin-right: 4px;
        font-size: 14px;
      }

      &.el-button--primary {
        background: linear-gradient(135deg, #409eff 0%, #66b3ff 100%);
        border-color: #409eff;
        box-shadow: 0 2px 4px rgba(64, 158, 255, 0.3);
      }

      &.el-button--default {
        background: #ffffff;
        border-color: #dcdfe6;
        color: #606266;

        &:hover {
          background: #f5f7fa;
          border-color: #409eff;
          color: #409eff;
        }
      }

      &:first-child {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }

      &:last-child {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        border-left: none;
      }
    }
  }
}

/* 发送按钮图标样式 */
.send_icon {
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    transform: scale(1.1);
    opacity: 0.8;
  }

  &:active {
    transform: scale(0.95);
  }

  &.disabled {
    cursor: not-allowed;
    opacity: 0.5;
    filter: grayscale(100%);

    &:hover {
      transform: none;
      opacity: 0.5;
    }

    &:active {
      transform: none;
    }
  }
}

/* 底部紧急悬浮提示样式 */
.urgent-floating-tip-bottom {
  position: absolute;
  bottom: 200px;
  left: 50%;
  transform: translateX(-50%);
  background: #ff4444;
  color: white;
  padding: 8px 20px;
  border-radius: 25px;
  font-size: 14px;
  font-weight: 500;
  box-shadow: 0 4px 12px rgba(255, 68, 68, 0.3);
  z-index: 33;
  animation: pulse 2s infinite;
  white-space: nowrap;
}

@keyframes pulse {
  0% {
    opacity: 1;
    transform: translateX(-50%) scale(1);
  }

  50% {
    opacity: 0.8;
    transform: translateX(-50%) scale(1.05);
  }

  100% {
    opacity: 1;
    transform: translateX(-50%) scale(1);
  }
}

// 被拉黑状态样式
.blocked-input {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 120px;
  background-color: #f5f5f5;
  border-radius: 20px;
  margin-top: 40px;
  padding-top: 0 !important;

  .blocked-message {
    display: flex;
    align-items: center;
    padding: 20px;
    background-color: #fff;
    border-radius: 12px;
    border: 1px solid #e8e8e8;

    .blocked-icon {
      margin-right: 16px;

      i {
        font-size: 20px;
        color: #f56c6c;
      }
    }

    .blocked-text {
      .blocked-title {
        font-size: 16px;
        color: #333;
      }
    }
  }
}
</style>
